<template>
<div>
<div class="mct-member-profile mct-thai-font" v-once>
<!-- start page title -->
<div class="row">
    <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
            <h4 class="mb-sm-0">{{ profileTitle }}</h4>
            <div class="page-title-right">
                <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a :href="listUrl">จัดการสมาชิกนักแต่ง</a></li>
                    <li class="breadcrumb-item"><a :href="listUrl">{{ listLabel }}</a></li>
                    <li class="breadcrumb-item active">โปรไฟล์</li>
                </ol>
            </div>
        </div>
    </div>
</div>

<div id="mct-profile-alert"></div>

<div class="profile-foreground position-relative mx-n4 mt-n4 d-none" id="mct-profile-hero-wrap">
    <div class="profile-wid-bg">
        <img :src="coverSrc" alt="" class="profile-wid-img" />
    </div>
</div>

<div class="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper d-none" id="mct-profile-header-wrap">
    <div class="row g-4 align-items-center">
        <div class="col-auto">
            <div class="avatar-lg mct-profile-user">
                <img id="mct-profile-avatar-image" class="rounded-circle mct-profile-avatar-image d-none" alt="รูปโปรไฟล์สมาชิก">
                <span class="avatar-title rounded-circle bg-primary-subtle text-primary fs-2 fw-semibold d-inline-flex align-items-center justify-content-center w-100 h-100" id="mct-profile-avatar-initial">—</span>
                <div class="avatar-xs p-0 rounded-circle mct-profile-photo-edit">
                    <input id="mct-profile-avatar-file" type="file" class="d-none" accept="image/jpeg,image/png,image/webp">
                    <label for="mct-profile-avatar-file" class="avatar-xs mb-0" title="อัปโหลดรูปโปรไฟล์">
                        <span class="avatar-title rounded-circle bg-light text-body material-shadow">
                            <i class="ri-camera-fill"></i>
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="p-2">
                <h3 class="text-white mb-1 mct-thai-font" id="mct-profile-display-name">—</h3>
                <p class="text-white text-opacity-75 mb-2" id="mct-profile-subtitle">—</p>
                <div class="vstack text-white-50 gap-2 gap-sm-3">
                    <div class="d-flex flex-wrap align-items-baseline column-gap-2 row-gap-1">
                        <span class="text-white text-opacity-75 flex-shrink-0"><i class="ri-barcode-line me-1"></i>รหัสสมาชิก</span>
                        <span class="text-white text-break font-monospace user-select-all" id="mct-profile-member-code">—</span>
                    </div>
                    <div class="d-flex flex-wrap align-items-baseline column-gap-2 row-gap-1">
                        <span class="text-white text-opacity-75 flex-shrink-0"><i class="ri-fingerprint-line me-1"></i>Internal No.</span>
                        <span class="text-white text-break font-monospace user-select-all" id="mct-profile-internal-no">—</span>
                    </div>
                    <div class="d-flex flex-wrap align-items-baseline column-gap-2 row-gap-1">
                        <span class="text-white text-opacity-75 flex-shrink-0"><i class="ri-hashtag me-1"></i>IPI Name No.</span>
                        <span class="text-white text-break font-monospace user-select-all" id="mct-profile-ipi-name">—</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-auto">
            <a :href="listUrl" class="btn btn-light"><i class="ri-arrow-left-line align-bottom"></i> กลับรายการ</a>
        </div>
    </div>
</div>

<div class="card d-none" id="mct-profile-empty">
    <div class="card-body">
        <p class="text-muted mb-3">ไม่ได้ระบุรหัสสมาชิก — เปิดจากปุ่ม <strong>View</strong> ใน{{ listLabel }}</p>
        <a :href="listUrl" class="btn btn-primary">ไป{{ listLabel }}</a>
    </div>
</div>

<div class="row d-none" id="mct-profile-body">
    <div class="col-xxl-2">
        <div class="card border-0 shadow-sm mb-3 overflow-hidden">
            <div class="bg-primary bg-opacity-10 px-3 py-3 border-bottom border-primary border-opacity-25">
                <div class="d-flex align-items-start gap-2">
                    <span class="avatar-xs rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2.25rem; height: 2.25rem;">
                        <i class="ri-shield-check-line fs-18"></i>
                    </span>
                    <div class="min-w-0">
                        <h5 class="card-title mb-1 fs-12">รหัสสมาชิกและเลขอ้างอิง</h5>
                        
                    </div>
                </div>
            </div>
            <ul class="list-unstyled mb-0">
                <li class="px-3 py-3 border-bottom border-light">
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-barcode-line fs-16"></i>
                        </span>
                        <div class="min-w-0 flex-grow-1">
                            <div class="small fw-semibold text-body-secondary text-uppercase fs-11 mb-1">รหัสสมาชิก</div>
                            <p class="mb-0 font-monospace text-break user-select-all text-body" id="mct-detail-member-code">—</p>
                        </div>
                    </div>
                </li>
                <li class="px-3 py-3 border-bottom border-light">
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-info-subtle text-info d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-fingerprint-line fs-16"></i>
                        </span>
                        <div class="min-w-0 flex-grow-1">
                            <div class="small fw-semibold text-body-secondary text-uppercase fs-11 mb-1">Internal No.</div>
                            <p class="mb-0 font-monospace text-break user-select-all text-body" id="mct-detail-internal-no">—</p>
                        </div>
                    </div>
                </li>
                <li class="px-3 py-3 border-bottom border-light">
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-success-subtle text-success d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-hashtag fs-16"></i>
                        </span>
                        <div class="min-w-0 flex-grow-1">
                            <div class="small fw-semibold text-body-secondary text-uppercase fs-11 mb-1">IPI Name No.</div>
                            <p class="mb-0 font-monospace text-break user-select-all text-body" id="mct-detail-ipi-name">—</p>
                        </div>
                    </div>
                </li>
                <li class="px-3 py-3">
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-warning-subtle text-warning d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-terminal-box-line fs-16"></i>
                        </span>
                        <div class="min-w-0 flex-grow-1">
                            <div class="small fw-semibold text-body-secondary text-uppercase fs-11 mb-1">IPI Base No.</div>
                            <p class="mb-0 font-monospace text-break user-select-all text-body" id="mct-field-ipi-base">—</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="card border-0 shadow-sm">
            <div class="card-body p-3">
                <div class="d-flex align-items-center gap-2 mb-3">
                    <span class="avatar-xs rounded-circle bg-secondary-subtle text-secondary d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                        <i class="ri-pulse-line fs-16"></i>
                    </span>
                    <h5 class="card-title mb-0 fs-15">สถานะ</h5>
                </div>
                <div class="rounded-3 bg-body-secondary bg-opacity-50 border border-dashed p-3 text-center mb-3">
                    <span class="small text-muted d-block mb-2">สถานะปัจจุบัน</span>
                    <span id="mct-field-status" class="badge rounded-pill fs-14 fw-semibold px-3 py-2 text-bg-secondary">—</span>
                    <span class="small text-muted d-block mt-3 mb-2">นำเข้าข้อมูล</span>
                    <span id="mct-field-created-source" class="badge rounded-pill fs-12 fw-semibold px-3 py-2 text-bg-light">—</span>
                </div>
                <div class="vstack gap-3">
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-success-subtle text-success d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-calendar-check-line fs-16"></i>
                        </span>
                        <div class="min-w-0">
                            <div class="small text-muted mb-0">วันที่สร้าง</div>
                            <div class="fw-medium text-body text-break fs-10" id="mct-field-created">—</div>
                        </div>
                    </div>
                    <div class="d-flex align-items-start gap-3">
                        <span class="avatar-xs rounded bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width: 2rem; height: 2rem;">
                            <i class="ri-time-line fs-16"></i>
                        </span>
                        <div class="min-w-0">
                            <div class="small text-muted mb-0">อัปเดตล่าสุด</div>
                            <div class="fw-medium text-body text-break fs-10" id="mct-field-updated">—</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-xxl-10">
        <div class="card mb-3 shadow-none border" id="mct-detail-tabs-card">
            <div class="card-body">
                <ul class="nav nav-pills nav-justified flex-nowrap gap-1 gap-sm-0 mb-4 overflow-auto" role="tablist">
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1" role="presentation">
                        <button type="button" class="nav-link active w-100 py-2 py-md-3" id="mct-detail-tab-primary-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-primary" role="tab" aria-controls="mct-detail-pane-primary" aria-selected="true">
                            <span id="mct-detail-tab-primary-label"><i class="ri-user-3-line align-middle me-1 text-primary"></i>ข้อมูลบุคคล/นักแต่งเพลง</span>
                        </button>
                    </li>
                    <li :class="['nav-item', 'flex-shrink-0', 'flex-sm-grow-1', { 'd-none': isSuccessor }]" role="presentation" id="mct-detail-tab-pen-item">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-pen-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-pen" role="tab" aria-controls="mct-detail-pane-pen" aria-selected="false">
                            <span id="mct-detail-tab-pen-label"><i class="ri-quill-pen-line align-middle me-1"></i>นามปากกา</span>
                        </button>
                    </li>
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1" role="presentation">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-contact-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-contact" role="tab" aria-controls="mct-detail-pane-contact" aria-selected="false">
                            <i class="ri-contacts-book-2-line align-middle me-1"></i><span class="d-none d-md-inline">ช่องทางติดต่อ</span><span class="d-md-none">ติดต่อ</span>
                        </button>
                    </li>
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1 d-none" role="presentation" id="mct-detail-tab-heir-item">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-heir-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-heir" role="tab" aria-controls="mct-detail-pane-heir" aria-selected="false">
                            <i class="ri-group-line align-middle me-1"></i><span class="d-none d-md-inline">ทายาท</span><span class="d-md-none">ทายาท</span>
                        </button>
                    </li>
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1" role="presentation">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-bank-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-bank" role="tab" aria-controls="mct-detail-pane-bank" aria-selected="false">
                            <i class="ri-bank-line align-middle me-1"></i><span class="d-none d-md-inline">บัญชีธนาคาร</span><span class="d-md-none">ธนาคาร</span>
                        </button>
                    </li>
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1" role="presentation">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-docs-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-docs" role="tab" aria-controls="mct-detail-pane-docs" aria-selected="false">
                            <i class="ri-folder-2-line align-middle me-1"></i><span class="d-none d-md-inline">ไฟล์เอกสาร</span><span class="d-md-none">เอกสาร</span>
                        </button>
                    </li>
                    <li class="nav-item flex-shrink-0 flex-sm-grow-1" role="presentation">
                        <button type="button" class="nav-link w-100 py-2 py-md-3" id="mct-detail-tab-audit-btn" data-bs-toggle="tab" data-bs-target="#mct-detail-pane-audit" role="tab" aria-controls="mct-detail-pane-audit" aria-selected="false">
                            <i class="ri-history-line align-middle me-1"></i><span class="d-none d-md-inline">ประวัติ</span><span class="d-md-none">ประวัติ</span>
                        </button>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane fade show active" id="mct-detail-pane-primary" role="tabpanel" aria-labelledby="mct-detail-tab-primary-btn" tabindex="0">
                        <div id="mct-personal-tab-alert" class="mb-3"></div>
                        <div id="mct-personal-card" class="card border-0 shadow-sm mb-3 overflow-hidden">
                            <div class="card-header bg-primary bg-opacity-10 border-bottom border-primary border-opacity-25 py-3">
                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                    <h5 class="card-title mb-0 fs-15 d-flex align-items-center gap-2">
                                        <i class="ri-user-3-line text-primary fs-18"></i>
                                        ข้อมูลบุคคล
                                    </h5>
                                    <div class="d-flex align-items-center gap-2 ms-auto">
                                        <a href="#" class="btn btn-sm btn-soft-primary" id="mct-btn-edit-personal">
                                            <i class="ri-edit-2-line align-bottom me-1"></i>Edit ข้อมูลบุคคล
                                        </a>
                                        <a href="#" class="btn btn-sm btn-soft-secondary d-none ms-2" id="mct-btn-cancel-personal">
                                            <i class="ri-close-line align-bottom me-1"></i>ยกเลิก
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <div class="table-responsive">
                                    <table class="table table-borderless align-middle mb-0">
                                        <tbody>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row" style="width: 34%;">คำนำหน้า</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body" id="mct-pi-title">—</td>
                                            </tr>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row">ชื่อ–นามสกุล (ไทย)</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body fw-medium mct-thai-font" id="mct-pi-name-th">—</td>
                                            </tr>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row">ชื่อ–นามสกุล (อังกฤษ)</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body" id="mct-pi-name-en">—</td>
                                            </tr>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row">เลขบัตรประชาชน / เลขผู้เสียภาษี</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body font-monospace text-break user-select-all" id="mct-pi-id-card">—</td>
                                            </tr>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row">วันเกิด</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body" id="mct-pi-birth">—</td>
                                            </tr>
                                            <tr>
                                                <th class="ps-3 ps-md-4 py-3 text-muted fw-semibold" scope="row">สัญชาติ</th>
                                                <td class="pe-3 pe-md-4 py-3 text-body" id="mct-pi-nationality">—</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div id="mct-writer-info-section" class="card border-0 shadow-sm d-none overflow-hidden">
                            <div class="card-header bg-info bg-opacity-10 border-bottom border-info border-opacity-25 py-3">
                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                    <h5 class="card-title mb-0 fs-15 d-flex align-items-center gap-2">
                                        <i class="ri-music-2-line text-info fs-18"></i>
                                        ข้อมูลนักแต่งเพลง
                                    </h5>
                                    <div class="d-flex align-items-center gap-2 ms-auto">
                                        <a href="#" class="btn btn-sm btn-soft-info" id="mct-btn-edit-writer">
                                            <i class="ri-edit-2-line align-bottom me-1"></i>Edit ข้อมูลนักแต่งเพลง
                                        </a>
                                        <a href="#" class="btn btn-sm btn-soft-secondary d-none ms-2" id="mct-btn-cancel-writer">
                                            <i class="ri-close-line align-bottom me-1"></i>ยกเลิก
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-3 p-md-4">
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-25">
                                            <div class="small text-muted mb-1">ประเภทนักแต่ง</div>
                                            <div class="fw-semibold text-body text-break" id="mct-field-writer-type">—</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-25">
                                            <div class="small text-muted mb-1">ประเภทผู้ทรงสิทธิ</div>
                                            <div class="fw-semibold text-body text-break" id="mct-field-rightsholder-type">—</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-25">
                                            <div class="small text-muted mb-1">แนวเพลง</div>
                                            <div class="fw-semibold text-body text-break" id="mct-field-genre">—</div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-25">
                                            <div class="small text-muted mb-1">บทบาทการสร้างสรรค์</div>
                                            <div class="fw-semibold text-body text-break" id="mct-field-roles">—</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-25">
                                            <div class="small text-muted mb-1">สังกัด Publisher</div>
                                            <div class="fw-semibold text-body text-break" id="mct-field-affiliated-publisher">—</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-none rounded-3 border border-success border-opacity-25 p-3" id="mct-org-card">
                            <div class="table-responsive">
                                <table class="table table-borderless mb-0">
                                    <tbody>
                                        <tr>
                                            <th class="ps-0" scope="row" style="width: 28%;">ชื่อองค์กร (ไทย)</th>
                                            <td class="text-muted" id="mct-org-local">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">สาขา / คำอธิบาย</th>
                                            <td class="text-muted" id="mct-org-branch">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">ชื่อองค์กร (อังกฤษ)</th>
                                            <td class="text-muted" id="mct-org-eng">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">Trading name (EN)</th>
                                            <td class="text-muted" id="mct-org-trading">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">เลขผู้เสียภาษี</th>
                                            <td class="text-muted" id="mct-org-tax">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">ทะเบียนนิติบุคคล</th>
                                            <td class="text-muted" id="mct-org-juristic">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">วันที่จัดตั้ง</th>
                                            <td class="text-muted" id="mct-org-established">—</td>
                                        </tr>
                                        <tr>
                                            <th class="ps-0" scope="row">ประเทศจดทะเบียน</th>
                                            <td class="text-muted" id="mct-org-country">—</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="mct-detail-pane-contact" role="tabpanel" aria-labelledby="mct-detail-tab-contact-btn" tabindex="0">
                        <div id="mct-contact-tab-alert" class="mb-3"></div>
                        <div class="d-flex gap-3 mb-4 pb-4 ">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                            <i class="ri-mail-send-line fs-18"></i>
                        </span>
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
                            <h6 class="fs-13 text-uppercase text-muted fw-semibold mb-0">อีเมล</h6>
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการอีเมล">
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-email-edit">Edit อีเมล</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-email-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div id="mct-contact-emails" class="vstack gap-2"></div>
                    </div>
                </div>

                <div class="d-flex gap-3 mb-4 pb-4 ">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded-circle bg-info-subtle text-info">
                            <i class="ri-phone-line fs-18"></i>
                        </span>
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
                            <h6 class="fs-13 text-uppercase text-muted fw-semibold mb-0">โทรศัพท์ (สำนักงาน)</h6>
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการโทรศัพท์สำนักงาน">
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-phone-edit">Edit โทรศัพท์ (สำนักงาน)</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-phone-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div id="mct-contact-phones" class="vstack gap-2"></div>
                    </div>
                </div>

                <div class="d-flex gap-3 mb-4 pb-4 ">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded-circle bg-success-subtle text-success">
                            <i class="ri-smartphone-line fs-18"></i>
                        </span>
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
                            <h6 class="fs-13 text-uppercase text-muted fw-semibold mb-0">มือถือ</h6>
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการมือถือ">
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-mobile-edit">Edit มือถือ</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-mobile-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div id="mct-contact-mobiles" class="vstack gap-2"></div>
                    </div>
                </div>

                <div class="d-flex gap-3 mb-4">
                    <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded-circle bg-warning-subtle text-warning">
                            <i class="ri-map-pin-line fs-18"></i>
                        </span>
                    </div>
                    <div class="flex-grow-1 min-w-0">
                        <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
                            <h6 class="fs-13 text-uppercase text-muted fw-semibold mb-0">ที่อยู่</h6>
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการที่อยู่">
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-address-edit">Edit ที่อยู่</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-address-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div id="mct-address-box" class="rounded-3 bg-light bg-opacity-50 border border-dashed p-3">
                            <p class="text-muted small mb-0 lh-base" id="mct-address-text">—</p>
                        </div>
                        <div id="mct-address-inline-actions" class="mt-2"></div>
                    </div>
                </div>

                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-3">
                    <h6 class="fs-13 text-uppercase text-muted fw-semibold mb-0">
                        <i class="ri-share-forward-line me-1"></i>โซเชียล / อื่น ๆ
                    </h6>
                    <div class="btn-group btn-group-sm" role="group" aria-label="จัดการโซเชียล">
                        <a href="#" class="btn btn-soft-primary" id="mct-btn-social-edit">Edit โซเชียล / อื่น ๆ</a>
                        <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-social-cancel">ยกเลิก</a>
                    </div>
                </div>
                <div class="row g-2">
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-success mb-1">
                                <i class="ri-chat-smile-2-line fs-16"></i>
                                <span class="small fw-semibold text-body">Line ID</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-line">—</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-primary mb-1">
                                <i class="ri-facebook-circle-fill fs-16"></i>
                                <span class="small fw-semibold text-body">Facebook</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-fb">—</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-danger mb-1">
                                <i class="ri-youtube-fill fs-16"></i>
                                <span class="small fw-semibold text-body">YouTube</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-youtube">—</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-dark mb-1">
                                <i class="ri-tiktok-fill fs-16"></i>
                                <span class="small fw-semibold text-body">TikTok</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-tiktok">—</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-danger mb-1">
                                <i class="ri-instagram-line fs-16"></i>
                                <span class="small fw-semibold text-body">Instagram</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-instagram">—</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-info mb-1">
                                <i class="ri-twitter-x-line fs-16"></i>
                                <span class="small fw-semibold text-body">X (Twitter)</span>
                            </div>
                            <p class="mb-0 text-break user-select-all" id="mct-social-x">—</p>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="rounded-3 border border-dashed p-3 h-100 bg-body-secondary bg-opacity-10">
                            <div class="d-flex align-items-center gap-2 text-muted mb-1">
                                <i class="ri-sticky-note-line fs-16"></i>
                                <span class="small fw-semibold text-body">หมายเหตุ</span>
                            </div>
                            <p class="mb-0 text-break" id="mct-social-note">—</p>
                        </div>
                    </div>
                </div>
                    </div>

                    <div :class="['tab-pane', 'fade', { 'd-none': isSuccessor }]" id="mct-detail-pane-heir" role="tabpanel" aria-labelledby="mct-detail-tab-heir-btn" tabindex="0">
                        <div class="card border-0 shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title fs-15 mb-2 d-flex align-items-center gap-2">
                                    <i class="ri-group-line text-primary"></i>ข้อมูลทายาท
                                </h5>
                                <p class="text-muted small mb-3">รายการผู้มีสิทธิ (ทายาท) ที่เชื่อมกับสมาชิกนักแต่งเพลงนี้</p>
                                <div class="table-responsive">
                                    <table class="table table-hover table-borderless align-middle mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th class="text-muted small">รหัสผู้มีสิทธิ</th>
                                                <th class="text-muted small">ชื่อผู้มีสิทธิ</th>
                                                <th class="text-muted small">Internal No.</th>
                                                <th class="text-muted small">IPI Name No.</th>
                                                <th class="text-muted small">สถานะความสัมพันธ์</th>
                                            </tr>
                                        </thead>
                                        <tbody id="mct-heir-rows">
                                            <tr><td colspan="5" class="text-muted small fst-italic">ยังไม่มีข้อมูลทายาท</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div :class="['tab-pane', 'fade', { 'd-none': isSuccessor }]" id="mct-detail-pane-pen" role="tabpanel" aria-labelledby="mct-detail-tab-pen-btn" tabindex="0">
                        <div id="mct-pen-tab-alert" class="mb-3"></div>
                        <div class="d-flex justify-content-end mb-2" id="mct-pen-action-wrap">
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการนามปากกา">
                                <a href="#" class="btn btn-soft-success me-2 d-none" id="mct-btn-pen-add">เพิ่มนามปากกา</a>
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-pen-edit">แก้ไขนามปากกา</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-pen-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div id="mct-pen-pane-desc-wrap" class="mb-2 d-none">
                            <p class="text-muted small mb-2" id="mct-pen-pane-desc">นักแต่งเพลงในสังกัด ที่เป็นสมาชิก MCT</p>
                        </div>
                        <p class="text-muted small mb-2" id="mct-pen-ipi-hint">IPI Name No และ IPI Base No. ของนามปากกาแยกจากเลขหลักของสมาชิก — ไม่ใช้ IPI Name No / IPI Base No. หลัก</p>
                        <div class="table-responsive mct-pen-table-scroll">
                            <table class="table table-hover table-borderless align-middle mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th scope="col" class="text-muted small">Internal No.</th>
                                        <th scope="col" class="text-muted small">IPI Name No</th>
                                        <th scope="col" class="text-muted small">IPI Base No.</th>
                                        <th scope="col" class="text-muted small">ชื่อ–นามสกุล (ไทย)</th>
                                        <th scope="col" class="text-muted small">ชื่อ–นามสกุล (อังกฤษ)</th>
                                    </tr>
                                </thead>
                                <tbody id="mct-pen-names-body"></tbody>
                            </table>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="mct-detail-pane-bank" role="tabpanel" aria-labelledby="mct-detail-tab-bank-btn" tabindex="0">
                        <div id="mct-bank-tab-alert" class="mb-3"></div>
                        <div class="d-flex justify-content-end mb-2">
                            <div class="btn-group btn-group-sm" role="group" aria-label="จัดการบัญชีธนาคาร">
                                <a href="#" class="btn btn-soft-success me-2 d-none" id="mct-btn-bank-add">เพิ่มบัญชีธนาคาร</a>
                                <a href="#" class="btn btn-soft-primary" id="mct-btn-bank-edit">แก้ไขบัญชีธนาคาร</a>
                                <a href="#" class="btn btn-soft-secondary d-none ms-2" id="mct-btn-bank-cancel">ยกเลิก</a>
                            </div>
                        </div>
                        <div>
                            <table class="table table-hover table-borderless align-middle mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th class="text-muted small" style="width: 3rem;">#</th>
                                        <th class="text-muted small" style="width: 250px;">ธนาคาร</th>
                                        <th class="text-muted small">ชื่อบัญชี</th>
                                        <th class="text-muted small">เลขที่บัญชี</th>
                                        <th class="text-muted small">สาขา</th>
                                        <th class="text-muted small">ประเภท</th>
                                    </tr>
                                </thead>
                                <tbody id="mct-bank-accounts-body"></tbody>
                            </table>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="mct-detail-pane-docs" role="tabpanel" aria-labelledby="mct-detail-tab-docs-btn" tabindex="0">
                        <div id="mct-docs-tab-alert" class="mb-3"></div>
                        <div class="card border-0 shadow-sm overflow-hidden mct-docs-fm">
                            <div class="card-header bg-primary bg-opacity-10 border-bottom border-primary border-opacity-25 py-3">
                                <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                                    <h5 class="card-title mb-0 fs-15 d-flex align-items-center gap-2">
                                        <span class="avatar-xs rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 2rem; height: 2rem;">
                                            <i class="ri-folder-2-line fs-16"></i>
                                        </span>
                                        ไฟล์เอกสาร
                                        <span class="badge bg-primary-subtle text-primary fw-medium" id="mct-doc-count-badge">0 ไฟล์</span>
                                    </h5>
                                    <div class="mct-docs-quota">
                                        <div class="d-flex justify-content-between align-items-center mb-1 column-gap-3">
                                            <span class="small text-muted">พื้นที่จัดเก็บ</span>
                                            <span class="small fw-semibold text-nowrap" id="mct-doc-usage-text">0 B / 1 GB</span>
                                        </div>
                                        <div class="progress progress-sm mct-docs-quota-bar">
                                            <div class="progress-bar" id="mct-doc-usage-bar" role="progressbar" style="width: 0%" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-3 p-md-4">
                                <div class="row g-3">
                                    <div class="col-lg-3">
                                        <div class="mct-docs-sidebar">
                                            <div class="small fw-semibold text-muted text-uppercase fs-11 mb-2">โฟลเดอร์</div>
                                            <div id="mct-doc-folder-tree" class="mct-docs-tree"></div>
                                        </div>
                                    </div>
                                    <div class="col-lg-9">
                                        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                            <nav id="mct-doc-breadcrumb" class="mct-docs-breadcrumb small" aria-label="ตำแหน่งโฟลเดอร์"></nav>
                                            <div class="d-flex flex-wrap align-items-center gap-2 ms-auto">
                                                <div class="mct-docs-search">
                                                    <i class="ri-search-line"></i>
                                                    <input type="search" id="mct-doc-search" class="form-control form-control-sm" placeholder="ค้นหาไฟล์หรือชื่อเอกสาร" autocomplete="off">
                                                </div>
                                                <button type="button" class="btn btn-sm btn-soft-primary" id="mct-btn-doc-toggle-folder-form">
                                                    <i class="ri-folder-add-line align-bottom me-1"></i>โฟลเดอร์ใหม่
                                                </button>
                                                <button type="button" class="btn btn-sm btn-soft-danger" id="mct-btn-doc-delete-folder" disabled>
                                                    <i class="ri-delete-bin-5-line align-bottom me-1"></i>ลบโฟลเดอร์นี้
                                                </button>
                                            </div>
                                        </div>

                                        <div id="mct-doc-folder-form" class="mct-docs-folder-form d-none mb-3">
                                            <label class="form-label small mb-1" for="mct-doc-new-folder-name">ชื่อโฟลเดอร์ใหม่ในตำแหน่งปัจจุบัน</label>
                                            <div class="d-flex flex-wrap gap-2">
                                                <input type="text" id="mct-doc-new-folder-name" class="form-control form-control-sm" placeholder="เช่น สัญญา, บัตรประชาชน" maxlength="120">
                                                <button type="button" class="btn btn-sm btn-primary" id="mct-btn-doc-create-folder">
                                                    <i class="ri-check-line align-bottom me-1"></i>สร้าง
                                                </button>
                                            </div>
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label small mb-1" for="mct-doc-upload-label">ชื่อเอกสาร (ไม่บังคับ)</label>
                                            <input type="text" id="mct-doc-upload-label" class="form-control form-control-sm" placeholder="เช่น สำเนาบัตรประชาชน" maxlength="200">
                                        </div>

                                        <input type="file" id="mct-doc-upload-file" class="d-none" accept=".pdf,.docx,.xlsx,.xls,.txt,.jpg,.jpeg,.png" multiple>
                                        <div id="mct-doc-dropzone" class="mct-docs-dropzone mb-3" role="button" tabindex="0">
                                            <div class="mct-docs-dropzone-icon">
                                                <i class="ri-upload-cloud-2-line"></i>
                                            </div>
                                            <div class="fw-semibold" id="mct-doc-dropzone-status">ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์</div>
                                            <div class="small text-muted mt-1">PDF, Word, Excel, รูปภาพ, ข้อความ · อัปโหลดเข้าโฟลเดอร์ที่เปิดอยู่</div>
                                        </div>
                                        <button type="button" class="d-none" id="mct-btn-doc-upload-file" tabindex="-1">อัปโหลด</button>

                                        <div id="mct-doc-files-body" class="mct-docs-files">
                                            <div class="text-muted small fst-italic py-4 text-center">ยังไม่มีเอกสาร</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="mct-detail-pane-audit" role="tabpanel" aria-labelledby="mct-detail-tab-audit-btn" tabindex="0">
                        <div class="card border-0 shadow-sm overflow-hidden">
                            <div class="card-header bg-secondary bg-opacity-10 border-bottom border-secondary border-opacity-25 py-3">
                                <h5 class="card-title mb-0 fs-15 d-flex align-items-center gap-2">
                                    <span class="avatar-xs rounded-circle bg-secondary-subtle text-secondary d-inline-flex align-items-center justify-content-center" style="width: 2rem; height: 2rem;">
                                        <i class="ri-history-line fs-16"></i>
                                    </span>
                                    ประวัติการแก้ไขโปรไฟล์
                                </h5>
                            </div>
                            <div class="card-body p-0">
                                <div class="table-responsive">
                                    <table class="table table-nowrap align-middle mb-0">
                                        <thead class="table-light text-muted">
                                            <tr>
                                                <th style="width: 11rem;">เวลา</th>
                                                <th style="width: 12rem;">ผู้อัปเดต</th>
                                                <th style="width: 10rem;">จุดที่แก้ไข</th>
                                                <th>รายละเอียด</th>
                                            </tr>
                                        </thead>
                                        <tbody id="mct-profile-audit-body">
                                            <tr>
                                                <td colspan="4" class="text-muted text-center py-4">ยังไม่มีประวัติ — จะปรากฏเมื่อมีการเพิ่มหรือแก้ไขข้อมูล</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xxl-12">
        <div :class="['card', 'mb-3', 'border', 'border-secondary', 'border-opacity-25', 'shadow-none', { 'd-none': isSuccessor }]" id="mct-song-works-card">
            <div class="card-body">
                <h5 class="card-title mb-3">
                    <i class="ri-music-2-line text-primary align-middle me-2"></i>ข้อมูลเพลง
                    <span class="text-muted fw-normal small" id="mct-song-works-count"></span>
                </h5>
                <p class="text-muted small mb-3">เพลงที่สมาชิกคนนี้แต่งทำนอง เนื้อร้อง เรียบเรียง หรือเป็น Publisher</p>
                <div class="row g-2 align-items-end mb-3">
                    <div class="col-md-7 col-lg-6">
                        <label class="form-label text-muted small mb-1" for="mct-song-works-search">ค้นหาเพลง</label>
                        <div class="search-box">
                            <input type="search" class="form-control form-control-sm" id="mct-song-works-search" placeholder="ชื่อเพลง, Work ID, ISWC, ศิลปิน, บทบาท, ผู้แต่งร่วม" autocomplete="off">
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-auto">
                        <label class="form-label text-muted small mb-1" for="mct-song-works-per-page">แถวต่อหน้า</label>
                        <select id="mct-song-works-per-page" class="form-select form-select-sm" style="width: 4.75rem;" aria-label="จำนวนแถวต่อหน้า">
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0 mct-profile-song-table">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" class="text-muted small" style="width: 3rem;">#</th>
                                <th scope="col" class="text-muted small">ชื่อเพลง</th>
                                <th scope="col" class="text-muted small">Work ID</th>
                                <th scope="col" class="text-muted small mct-profile-song-role-head is-melody">ทำนอง</th>
                                <th scope="col" class="text-muted small mct-profile-song-role-head is-lyrics">เนื้อร้อง</th>
                                <th scope="col" class="text-muted small mct-profile-song-role-head is-arrangement">เรียบเรียง</th>
                                <th scope="col" class="text-muted small mct-profile-song-role-head is-publisher">Publisher</th>
                                <th scope="col" class="text-muted small text-end" style="width: 4rem;"></th>
                            </tr>
                        </thead>
                        <tbody id="mct-song-works-body"></tbody>
                    </table>
                </div>
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mt-3" id="mct-song-works-pager">
                    <small class="text-muted" id="mct-song-works-page-info"></small>
                    <div class="pagination-wrap hstack gap-2 flex-wrap">
                        <button type="button" class="btn btn-sm btn-light" id="mct-song-works-prev" data-song-page-step="-1">ก่อนหน้า</button>
                        <ul class="pagination listjs-pagination mb-0" id="mct-song-works-page-list"></ul>
                        <button type="button" class="btn btn-sm btn-light" id="mct-song-works-next" data-song-page-step="1">ถัดไป</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
    <song-view-modal
        ref="songViewModal"
        :api-url="songDetailApiUrl"
        :base-path="config && config.basePath"
        :show-actions="false"
    />
</div>
</template>

<script>
import SongViewModal from "../components/SongViewModal.vue";

function runMemberProfile(config, hooks) {
        config = config || {};
        hooks = hooks || {};
        if (typeof window.$ !== "function") {
            var miniDollar = function (selector) {
                var el = document.querySelector(selector);
                return {
                    val: function (v) {
                        if (!el) return v === undefined ? "" : this;
                        if (v === undefined) return "value" in el ? el.value : (el.textContent || "");
                        if ("value" in el) el.value = v;
                        return this;
                    },
                    html: function (v) {
                        if (!el) return v === undefined ? "" : this;
                        if (v === undefined) return el.innerHTML;
                        el.innerHTML = String(v);
                        return this;
                    },
                    is: function (expr) {
                        if (!el) return false;
                        if (expr === ":checked") return !!el.checked;
                        return false;
                    },
                    addClass: function (cls) {
                        if (el) el.classList.add(cls);
                        return this;
                    },
                    removeClass: function (cls) {
                        if (el) el.classList.remove(cls);
                        return this;
                    }
                };
            };
            miniDollar.ajax = function (options) {
                var method = String((options && options.method) || "GET").toUpperCase();
                var url = String((options && options.url) || "");
                var data = (options && options.data) ? options.data : {};
                var headers = { "X-Requested-With": "XMLHttpRequest" };
                var body = null;
                if (method !== "GET") {
                    var params = new URLSearchParams();
                    Object.keys(data).forEach(function (k) {
                        var val = data[k];
                        params.append(k, val == null ? "" : String(val));
                    });
                    body = params;
                }
                var promise = fetch(url, {
                    method: method,
                    headers: headers,
                    body: body
                }).then(function (res) {
                    return res.text().then(function (text) {
                        var json = {};
                        try {
                            json = text ? JSON.parse(text) : {};
                        } catch (e) {
                            json = {};
                        }
                        if (!res.ok) {
                            var err = new Error((json && json.message) ? json.message : "Request failed");
                            err.responseJSON = json;
                            throw err;
                        }
                        return json;
                    });
                });
                return {
                    done: function (fn) {
                        promise.then(fn);
                        return this;
                    },
                    fail: function (fn) {
                        promise.catch(function (err) {
                            fn({ responseJSON: err && err.responseJSON ? err.responseJSON : null });
                        });
                        return this;
                    }
                };
            };
            window.$ = miniDollar;
        }

        var API_URL = String(config.apiUrl || "");
        var MEMBER_CODE = String(config.memberCode || "");
        var BASE_PATH = String(config.basePath || "");
        var IS_SUCCESSOR_PROFILE_PAGE = !!config.isSuccessor;
        var currentMember = null;
        var personalEditing = false;
        var writerEditing = false;
        var penEditing = false;
        var bankEditing = false;
        var bankMasterOptions = [];
        var inlineAddressRowSeq = 0;
        var inlineAddressDocBound = false;
        var contactEditing = {
            email: false,
            phone: false,
            mobile: false,
            address: false,
            social: false
        };
        var songWorksState = {
            all: [],
            query: "",
            page: 1,
            perPage: 10,
            bound: false,
            searchTimer: null
        };

        var els = {
            alert: document.getElementById("mct-profile-alert"),
            empty: document.getElementById("mct-profile-empty"),
            body: document.getElementById("mct-profile-body"),
            heroWrap: document.getElementById("mct-profile-hero-wrap"),
            headerWrap: document.getElementById("mct-profile-header-wrap"),
            avatar: document.getElementById("mct-profile-avatar-initial"),
            avatarImage: document.getElementById("mct-profile-avatar-image"),
            avatarFile: document.getElementById("mct-profile-avatar-file"),
            displayName: document.getElementById("mct-profile-display-name"),
            subtitle: document.getElementById("mct-profile-subtitle"),
            memberCode: document.getElementById("mct-profile-member-code"),
            internalNo: document.getElementById("mct-profile-internal-no"),
            ipiName: document.getElementById("mct-profile-ipi-name"),
            orgCard: document.getElementById("mct-org-card"),
            personalCard: document.getElementById("mct-personal-card"),
            writerInfoSection: document.getElementById("mct-writer-info-section"),
            docsAlert: document.getElementById("mct-docs-tab-alert"),
            docsNewFolderName: document.getElementById("mct-doc-new-folder-name"),
            docsUploadLabel: document.getElementById("mct-doc-upload-label"),
            docsUploadFile: document.getElementById("mct-doc-upload-file"),
            docsCreateBtn: document.getElementById("mct-btn-doc-create-folder"),
            docsDeleteBtn: document.getElementById("mct-btn-doc-delete-folder"),
            docsToggleFolderForm: document.getElementById("mct-btn-doc-toggle-folder-form"),
            docsFolderForm: document.getElementById("mct-doc-folder-form"),
            docsUploadBtn: document.getElementById("mct-btn-doc-upload-file"),
            docsUsageText: document.getElementById("mct-doc-usage-text"),
            docsUsageBar: document.getElementById("mct-doc-usage-bar"),
            docsFilesBody: document.getElementById("mct-doc-files-body"),
            docsFolderTree: document.getElementById("mct-doc-folder-tree"),
            docsBreadcrumb: document.getElementById("mct-doc-breadcrumb"),
            docsSearch: document.getElementById("mct-doc-search"),
            docsDropzone: document.getElementById("mct-doc-dropzone"),
            docsDropzoneStatus: document.getElementById("mct-doc-dropzone-status"),
            docsCountBadge: document.getElementById("mct-doc-count-badge")
        };
        var currentDocFolderPath = "";
        var currentDocSearchQuery = "";
        var docsUploading = false;

        function escapeHtml(text) {
            return String(text || "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        function safeDash(v) {
            var t = String(v || "").trim();
            return t === "" ? "—" : t;
        }

        function canonicalWriterType(value) {
            var s = String(value || "").trim().toLowerCase().replace(/\s+/g, " ");
            if (s === "general" || s === "general member") {
                return "General Member";
            }
            if (s === "associate" || s === "associate member") {
                return "Associate Member";
            }
            if (s === "provisional" || s === "provisional member") {
                return "Provisional Member";
            }
            return String(value || "").trim();
        }

        function showAlert(kind, message) {
            if (!els.alert) return;
            var cls = kind === "success" ? "success" : "danger";
            els.alert.innerHTML =
                '<div class="alert alert-' +
                cls +
                ' alert-dismissible fade show" role="alert">' +
                escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showPersonalSaveSuccessAlert(message) {
            var tabAlertEl = document.getElementById("mct-personal-tab-alert");
            if (!tabAlertEl) {
                if (!els.alert) return;
                els.alert.innerHTML =
                    '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                    '<strong>Success Alert:</strong> ' + escapeHtml(message) +
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
                return;
            }
            tabAlertEl.innerHTML =
                '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                '<strong>Success Alert:</strong> ' + escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showContactTabAlert(kind, message) {
            var contactAlertEl = document.getElementById("mct-contact-tab-alert");
            if (!contactAlertEl) {
                showAlert(kind, message);
                return;
            }
            var cls = kind === "success" ? "success" : "danger";
            contactAlertEl.innerHTML =
                '<div class="alert alert-' + cls + ' alert-dismissible fade show" role="alert">' +
                (kind === "success" ? '<strong>Success Alert:</strong> ' : '') +
                escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showBankTabAlert(kind, message) {
            var bankAlertEl = document.getElementById("mct-bank-tab-alert");
            if (!bankAlertEl) {
                showAlert(kind, message);
                return;
            }
            var cls = kind === "success" ? "success" : "danger";
            bankAlertEl.innerHTML =
                '<div class="alert alert-' + cls + ' alert-dismissible fade show" role="alert">' +
                (kind === "success" ? '<strong>Success Alert:</strong> ' : '') +
                escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showPenTabAlert(kind, message) {
            var penAlertEl = document.getElementById("mct-pen-tab-alert");
            if (!penAlertEl) {
                showAlert(kind, message);
                return;
            }
            var cls = kind === "success" ? "success" : "danger";
            penAlertEl.innerHTML =
                '<div class="alert alert-' + cls + ' alert-dismissible fade show" role="alert">' +
                (kind === "success" ? '<strong>Success Alert:</strong> ' : '') +
                escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showDocsTabAlert(kind, message) {
            if (!els.docsAlert) {
                showAlert(kind, message);
                return;
            }
            var cls = kind === "success" ? "success" : "danger";
            els.docsAlert.innerHTML =
                '<div class="alert alert-' + cls + ' alert-dismissible fade show" role="alert">' +
                (kind === "success" ? '<strong>Success Alert:</strong> ' : '') +
                escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function showWriterSaveSuccessAlert(message) {
            var tabAlertEl = document.getElementById("mct-personal-tab-alert");
            if (!tabAlertEl) {
                if (!els.alert) return;
                els.alert.innerHTML =
                    '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                    '<strong>Success Alert:</strong> ' + escapeHtml(message) +
                    '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
                return;
            }
            tabAlertEl.innerHTML =
                '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                '<strong>Success Alert:</strong> ' + escapeHtml(message) +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button></div>';
        }

        function profileInitial(name) {
            var text = String(name || "").trim();
            if (!text) return "M";
            return text.charAt(0).toUpperCase();
        }

        function setProfileAvatar(displayName, imagePath) {
            var initialText = profileInitial(displayName);
            if (els.avatar) {
                els.avatar.textContent = initialText;
            }
            var imageUrl = publicHref(imagePath);
            if (els.avatarImage && imageUrl) {
                els.avatarImage.src = imageUrl;
                els.avatarImage.classList.remove("d-none");
                if (els.avatar) {
                    els.avatar.classList.add("d-none");
                }
            } else {
                if (els.avatarImage) {
                    els.avatarImage.classList.add("d-none");
                    els.avatarImage.removeAttribute("src");
                }
                if (els.avatar) {
                    els.avatar.classList.remove("d-none");
                }
            }
        }

        function bindAvatarUpload() {
            if (!els.avatarFile) return;
            els.avatarFile.addEventListener("change", function () {
                if (!currentMember || !currentMember.member_code) {
                    showAlert("danger", "ไม่พบ member_code สำหรับอัปโหลดรูปโปรไฟล์");
                    els.avatarFile.value = "";
                    return;
                }
                var file = els.avatarFile.files && els.avatarFile.files[0] ? els.avatarFile.files[0] : null;
                if (!file) return;
                var allowed = ["image/jpeg", "image/png", "image/webp"];
                if (allowed.indexOf(String(file.type || "").toLowerCase()) === -1) {
                    showAlert("danger", "รองรับเฉพาะไฟล์ JPG, PNG, WEBP");
                    els.avatarFile.value = "";
                    return;
                }
                if (file.size > 5 * 1024 * 1024) {
                    showAlert("danger", "ขนาดไฟล์ต้องไม่เกิน 5MB");
                    els.avatarFile.value = "";
                    return;
                }

                var formData = new FormData();
                formData.append("action", "upload_profile_image");
                formData.append("member_code", String(currentMember.member_code || "").trim());
                formData.append("profile_image", file);

                fetch(API_URL, {
                    method: "POST",
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                    body: formData
                })
                    .then(function (res) {
                        return res.text().then(function (text) {
                            var data = {};
                            try {
                                data = text ? JSON.parse(text) : {};
                            } catch (e) {
                                throw new Error("API ไม่ได้ส่ง JSON ที่ถูกต้อง");
                            }
                            if (!res.ok || !data || data.success !== true) {
                                throw new Error((data && data.message) ? data.message : "อัปโหลดรูปโปรไฟล์ไม่สำเร็จ");
                            }
                            return data;
                        });
                    })
                    .then(function (data) {
                        var path = String((data && data.profile_image_path) || "").trim();
                        currentMember.profile_image_path = path;
                        setProfileAvatar(currentMember.display_name || "", path);
                        showPersonalSaveSuccessAlert((data && data.message) ? data.message : "อัปโหลดรูปโปรไฟล์เรียบร้อยแล้ว");
                        reloadAuditLogs();
                    })
                    .catch(function (err) {
                        showAlert("danger", err && err.message ? err.message : "อัปโหลดรูปโปรไฟล์ไม่สำเร็จ");
                    })
                    .finally(function () {
                        if (els.avatarFile) {
                            els.avatarFile.value = "";
                        }
                    });
            });
        }

        function formatRoles(m) {
            var parts = [];
            if (Number(m.creative_role_melody) === 1) parts.push("ทำนอง");
            if (Number(m.creative_role_lyrics) === 1) parts.push("เนื้อร้อง");
            if (Number(m.creative_role_arrangement) === 1) parts.push("เรียบเรียง");
            return parts.length ? parts.join(", ") : "—";
        }

        function memberStatusLabel(raw) {
            var s = String(raw || "").trim().toLowerCase();
            if (s === "active") {
                return "ใช้งาน";
            }
            if (s === "inactive") {
                return "ไม่ใช้งาน";
            }
            if (s === "suspended") {
                return "ระงับ";
            }
            if (s === "resigned") {
                return "ลาออก";
            }
            if (s === "deceased") {
                return "เสียชีวิต";
            }
            return String(raw || "").trim();
        }

        function memberStatusBadgeClass(raw) {
            var t = String(raw || "").trim();
            if (t === "" || t === "—") {
                return "text-bg-secondary";
            }
            var lower = t.toLowerCase();
            if (lower === "active" || t.indexOf("ใช้งาน") !== -1) {
                return "text-bg-success";
            }
            if (lower === "resigned" || t.indexOf("ลาออก") !== -1) {
                return "text-bg-dark";
            }
            if (lower === "deceased" || t.indexOf("เสียชีวิต") !== -1) {
                return "text-bg-danger";
            }
            if (lower === "suspended" || t.indexOf("ระงับ") !== -1) {
                return "text-bg-warning text-dark";
            }
            if (lower.indexOf("inactive") !== -1 || t.indexOf("ไม่ใช้งาน") !== -1 || t.indexOf("ปิดการ") !== -1) {
                return "text-bg-secondary";
            }
            if (lower.indexOf("pending") !== -1 || t.indexOf("รอ") !== -1 || t.indexOf("ชั่วคราว") !== -1) {
                return "text-bg-warning text-dark";
            }
            return "text-bg-primary";
        }

        function applyCreatedSourceBadge(value, label) {
            var el = document.getElementById("mct-field-created-source");
            if (!el) {
                return;
            }
            var s = String(value || "").trim().toLowerCase();
            var text = String(label || "").trim();
            if (text === "") {
                if (s === "online_application") {
                    text = "ใบสมัครออนไลน์";
                } else if (s === "manual_add") {
                    text = "เพิ่มสมาชิกออฟไลน์";
                } else {
                    text = "ไม่ระบุ";
                }
            }
            var icon = "";
            if (s === "online_application") {
                el.className = "badge rounded-pill fs-12 fw-semibold px-3 py-2 text-bg-info";
                icon = "ri-global-line";
            } else if (s === "manual_add") {
                el.className = "badge rounded-pill fs-12 fw-semibold px-3 py-2 text-bg-secondary";
                icon = "ri-computer-line";
            } else {
                el.className = "badge rounded-pill fs-12 fw-semibold px-3 py-2 text-bg-light text-muted";
            }
            el.textContent = "";
            if (icon) {
                var iEl = document.createElement("i");
                iEl.className = icon + " me-1 align-middle";
                el.appendChild(iEl);
            }
            el.appendChild(document.createTextNode(text));
        }

        function applyMemberStatusBadge(value) {
            var el = document.getElementById("mct-field-status");
            if (!el) {
                return;
            }
            var t = memberStatusLabel(value);
            el.textContent = t === "" ? "—" : t;
            el.className = "badge rounded-pill fs-14 fw-semibold px-3 py-2 " + memberStatusBadgeClass(t);
        }

        function setText(id, value) {
            var el = document.getElementById(id);
            if (el) el.textContent = safeDash(value);
        }

        function getCurrentPersonal() {
            if (!currentMember || !currentMember.personal || typeof currentMember.personal !== "object") {
                return {};
            }
            return currentMember.personal;
        }

        function setPersonalReadOnly(pi) {
            var idDigits = String(pi.id_card_number || "").replace(/\D/g, "");
            var idFormatted = idDigits.length === 13
                ? idDigits.slice(0, 1) + "-" + idDigits.slice(1, 5) + "-" + idDigits.slice(5, 10) + "-" + idDigits.slice(10, 12) + "-" + idDigits.slice(12, 13)
                : String(pi.id_card_number || "");
            setText("mct-pi-title", pi.title);
            var thName = [pi.first_name_local, pi.last_name_local].filter(function (x) {
                return String(x || "").trim();
            }).join(" ");
            setText("mct-pi-name-th", thName);
            var enName = [pi.first_name_eng, pi.last_name_eng].filter(function (x) {
                return String(x || "").trim();
            }).join(" ");
            setText("mct-pi-name-en", enName);
            setText("mct-pi-id-card", idFormatted);
            setText("mct-pi-birth", pi.birth_date);
            setText("mct-pi-nationality", pi.nationality);
        }

        function togglePersonalEditButton(loading) {
            var editBtn = document.getElementById("mct-btn-edit-personal");
            var cancelBtn = document.getElementById("mct-btn-cancel-personal");
            if (!editBtn || !cancelBtn) {
                return;
            }
            if (personalEditing) {
                editBtn.innerHTML = loading
                    ? '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>กำลังบันทึก...'
                    : '<i class="ri-save-line align-bottom me-1"></i>บันทึกข้อมูลบุคคล';
                cancelBtn.classList.remove("d-none");
            } else {
                editBtn.innerHTML = '<i class="ri-edit-2-line align-bottom me-1"></i>Edit ข้อมูลบุคคล';
                cancelBtn.classList.add("d-none");
            }
        }

        function renderPersonalInlineForm(pi) {
            var titleEl = document.getElementById("mct-pi-title");
            var thEl = document.getElementById("mct-pi-name-th");
            var enEl = document.getElementById("mct-pi-name-en");
            var idEl = document.getElementById("mct-pi-id-card");
            var birthEl = document.getElementById("mct-pi-birth");
            var nationEl = document.getElementById("mct-pi-nationality");
            if (!titleEl || !thEl || !enEl || !idEl || !birthEl || !nationEl) {
                return;
            }

            var titleOptions = ["", "นาย", "นาง", "นางสาว", "เด็กชาย", "เด็กหญิง", "ดร.", "ศ.ดร.", "รศ.ดร.", "ผศ.ดร."];
            titleEl.innerHTML =
                '<select class="form-select form-select-sm" id="mct-inline-title">' +
                titleOptions.map(function (opt) {
                    var selected = String(pi.title || "") === opt ? " selected" : "";
                    return '<option value="' + escapeHtml(opt) + '"' + selected + ">" + escapeHtml(opt || "— เลือก —") + "</option>";
                }).join("") +
                "</select>";
            thEl.innerHTML =
                '<div class="row g-2">' +
                '<div class="col-6"><input type="text" class="form-control form-control-sm" id="mct-inline-first-name-local" placeholder="ชื่อไทย" value="' + escapeHtml(pi.first_name_local || "") + '"></div>' +
                '<div class="col-6"><input type="text" class="form-control form-control-sm" id="mct-inline-last-name-local" placeholder="นามสกุลไทย" value="' + escapeHtml(pi.last_name_local || "") + '"></div>' +
                "</div>";
            enEl.innerHTML =
                '<div class="row g-2">' +
                '<div class="col-6"><input type="text" class="form-control form-control-sm" id="mct-inline-first-name-eng" placeholder="First name" value="' + escapeHtml(pi.first_name_eng || "") + '"></div>' +
                '<div class="col-6"><input type="text" class="form-control form-control-sm" id="mct-inline-last-name-eng" placeholder="Last name" value="' + escapeHtml(pi.last_name_eng || "") + '"></div>' +
                "</div>";
            var idDigits = String(pi.id_card_number || "").replace(/\D/g, "").slice(0, 13);
            var idFormatted = idDigits.length === 13
                ? idDigits.slice(0, 1) + "-" + idDigits.slice(1, 5) + "-" + idDigits.slice(5, 10) + "-" + idDigits.slice(10, 12) + "-" + idDigits.slice(12, 13)
                : idDigits;
            idEl.innerHTML = '<input type="text" class="form-control form-control-sm" id="mct-inline-id-card" maxlength="17" pattern="[0-9]-[0-9]{4}-[0-9]{5}-[0-9]{2}-[0-9]" value="' + escapeHtml(idFormatted) + '">';
            birthEl.innerHTML = '<input type="date" class="form-control form-control-sm" id="mct-inline-birth" value="' + escapeHtml(pi.birth_date || "") + '">';
            nationEl.innerHTML = '<input type="text" class="form-control form-control-sm" id="mct-inline-nationality" value="' + escapeHtml(pi.nationality || "") + '">';
        }

        function collectPersonalInlineValues() {
            return {
                title: String($("#mct-inline-title").val() || "").trim(),
                first_name_local: String($("#mct-inline-first-name-local").val() || "").trim(),
                last_name_local: String($("#mct-inline-last-name-local").val() || "").trim(),
                first_name_eng: String($("#mct-inline-first-name-eng").val() || "").trim(),
                last_name_eng: String($("#mct-inline-last-name-eng").val() || "").trim(),
                id_card_number: String($("#mct-inline-id-card").val() || "").trim(),
                birth_date: String($("#mct-inline-birth").val() || "").trim(),
                nationality: String($("#mct-inline-nationality").val() || "").trim()
            };
        }

        function beginPersonalEdit() {
            var pi = getCurrentPersonal();
            personalEditing = true;
            renderPersonalInlineForm(pi);
            togglePersonalEditButton(false);
        }

        function endPersonalEdit() {
            personalEditing = false;
            setPersonalReadOnly(getCurrentPersonal());
            togglePersonalEditButton(false);
        }

        function savePersonalInline() {
            if (!currentMember || !currentMember.member_code) {
                showAlert("danger", "ไม่พบ member_code สำหรับบันทึกข้อมูล");
                return;
            }

            var payload = collectPersonalInlineValues();
            if (!payload.title || !payload.first_name_local || !payload.last_name_local || !payload.first_name_eng || !payload.last_name_eng) {
                showAlert("danger", "กรุณากรอกคำนำหน้า ชื่อ และนามสกุล ให้ครบทั้งไทย/อังกฤษ");
                return;
            }
            if (payload.id_card_number) {
                var idDigits = payload.id_card_number.replace(/\D/g, "");
                if (idDigits.length !== 13) {
                    showAlert("danger", "เลขบัตรประชาชน/เลขผู้เสียภาษี ต้องมี 13 หลัก");
                    return;
                }
                payload.id_card_number = idDigits;
            } else {
                showAlert("danger", "กรุณากรอกเลขบัตรประชาชน/เลขผู้เสียภาษี");
                return;
            }

            togglePersonalEditButton(true);
            $.ajax({
                url: API_URL,
                method: "POST",
                dataType: "json",
                data: Object.assign({}, payload, {
                    action: "update_personal",
                    member_code: String(currentMember.member_code || "").trim()
                })
            })
                .done(function (res) {
                    if (!res || res.success !== true) {
                        showAlert("danger", (res && res.message) ? res.message : "บันทึกข้อมูลไม่สำเร็จ");
                        togglePersonalEditButton(false);
                        return;
                    }
                    currentMember.personal = res.personal || payload;
                    var displayName = [
                        currentMember.personal.title,
                        currentMember.personal.first_name_local,
                        currentMember.personal.last_name_local
                    ].filter(function (x) { return String(x || "").trim(); }).join(" ");
                    currentMember.display_name = displayName;
                    if (els.displayName) els.displayName.textContent = safeDash(displayName);
                    setProfileAvatar(displayName, (currentMember && currentMember.profile_image_path) ? currentMember.profile_image_path : "");
                    endPersonalEdit();
                    showPersonalSaveSuccessAlert((res && res.message) ? res.message : "บันทึกข้อมูลเรียบร้อยแล้ว");
                    reloadAuditLogs();
                })
                .fail(function (xhr) {
                    var msg = "บันทึกข้อมูลไม่สำเร็จ";
                    if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                        msg = xhr.responseJSON.message;
                    }
                    showAlert("danger", msg);
                    togglePersonalEditButton(false);
                });
        }

        function initPersonalInlineEditing() {
            var editBtn = document.getElementById("mct-btn-edit-personal");
            var cancelBtn = document.getElementById("mct-btn-cancel-personal");
            if (!editBtn || !cancelBtn) {
                return;
            }
            editBtn.addEventListener("click", function (event) {
                event.preventDefault();
                if (!personalEditing) {
                    beginPersonalEdit();
                    return;
                }
                savePersonalInline();
            });
            cancelBtn.addEventListener("click", function (event) {
                event.preventDefault();
                endPersonalEdit();
            });
        }

        function getCurrentWriter() {
            if (!currentMember || typeof currentMember !== "object") {
                return {};
            }
            return {
                writer_type: String(currentMember.writer_type || "").trim(),
                rightsholder_type: String(currentMember.rightsholder_type || "").trim(),
                genre: String(currentMember.genre || "").trim(),
                creative_role_melody: Number(currentMember.creative_role_melody) === 1 ? 1 : 0,
                creative_role_lyrics: Number(currentMember.creative_role_lyrics) === 1 ? 1 : 0,
                creative_role_arrangement: Number(currentMember.creative_role_arrangement) === 1 ? 1 : 0,
                affiliated_publisher: String(currentMember.affiliated_publisher || "").trim()
            };
        }

        function setWriterReadOnly(w) {
            setText("mct-field-writer-type", canonicalWriterType(w.writer_type));
            setText("mct-field-rightsholder-type", w.rightsholder_type);
            setText("mct-field-genre", w.genre);
            setText("mct-field-roles", formatRoles(w));
            setText("mct-field-affiliated-publisher", w.affiliated_publisher);
        }

        function toggleWriterEditButton(loading) {
            var editBtn = document.getElementById("mct-btn-edit-writer");
            var cancelBtn = document.getElementById("mct-btn-cancel-writer");
            if (!editBtn || !cancelBtn) {
                return;
            }
            if (writerEditing) {
                editBtn.innerHTML = loading
                    ? '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>กำลังบันทึก...'
                    : '<i class="ri-save-line align-bottom me-1"></i>บันทึกข้อมูลนักแต่งเพลง';
                cancelBtn.classList.remove("d-none");
            } else {
                editBtn.innerHTML = '<i class="ri-edit-2-line align-bottom me-1"></i>Edit ข้อมูลนักแต่งเพลง';
                cancelBtn.classList.add("d-none");
            }
        }

        function renderWriterInlineForm(w) {
            var writerEl = document.getElementById("mct-field-writer-type");
            var rightsEl = document.getElementById("mct-field-rightsholder-type");
            var genreEl = document.getElementById("mct-field-genre");
            var rolesEl = document.getElementById("mct-field-roles");
            var pubEl = document.getElementById("mct-field-affiliated-publisher");
            if (!writerEl || !rightsEl || !genreEl || !rolesEl || !pubEl) {
                return;
            }

            var writerTypes = ["", "General Member", "Associate Member", "Provisional Member"];
            writerEl.innerHTML =
                '<select class="form-select form-select-sm" id="mct-inline-writer-type">' +
                writerTypes.map(function (opt) {
                    var selected = canonicalWriterType(w.writer_type) === opt ? " selected" : "";
                    return '<option value="' + escapeHtml(opt) + '"' + selected + ">" + escapeHtml(opt || "— เลือก —") + "</option>";
                }).join("") +
                "</select>";
            rightsEl.innerHTML =
                '<div class="form-control form-control-sm bg-light text-muted" id="mct-inline-rightsholder-type-readonly">' +
                escapeHtml(safeDash(w.rightsholder_type)) +
                "</div>";
            genreEl.innerHTML = '<input type="text" class="form-control form-control-sm" id="mct-inline-genre" value="' + escapeHtml(w.genre || "") + '" placeholder="เช่น Pop, Rock">';
            rolesEl.innerHTML =
                '<div class="d-flex flex-wrap gap-3">' +
                '<div class="form-check"><input class="form-check-input" type="checkbox" id="mct-inline-role-melody" ' + (Number(w.creative_role_melody) === 1 ? "checked" : "") + '><label class="form-check-label" for="mct-inline-role-melody">ทำนอง</label></div>' +
                '<div class="form-check"><input class="form-check-input" type="checkbox" id="mct-inline-role-lyrics" ' + (Number(w.creative_role_lyrics) === 1 ? "checked" : "") + '><label class="form-check-label" for="mct-inline-role-lyrics">เนื้อร้อง</label></div>' +
                '<div class="form-check"><input class="form-check-input" type="checkbox" id="mct-inline-role-arrangement" ' + (Number(w.creative_role_arrangement) === 1 ? "checked" : "") + '><label class="form-check-label" for="mct-inline-role-arrangement">เรียบเรียง</label></div>' +
                "</div>";
            pubEl.innerHTML =
                '<div class="vstack gap-2">' +
                '<input type="text" class="form-control form-control-sm" id="mct-inline-affiliated-publisher-search" placeholder="ค้นหา Publisher จากฐานข้อมูล (อย่างน้อย 2 ตัวอักษร)" autocomplete="off">' +
                '<div id="mct-inline-affiliated-publisher-dropdown" class="list-group shadow-sm border rounded" style="display:none;max-height:220px;overflow-y:auto;"></div>' +
                '<input type="text" class="form-control form-control-sm" id="mct-inline-affiliated-publisher" value="' + escapeHtml(w.affiliated_publisher || "") + '" placeholder="ชื่อสังกัด Publisher">' +
                '<input type="hidden" id="mct-inline-affiliated-publisher-member-id" value="' + escapeHtml(String((currentMember && currentMember.affiliated_publisher_member_id) || "")) + '">' +
                '<small id="mct-inline-affiliated-publisher-status" class="text-muted"></small>' +
                "</div>";
        }

        function setupWriterPublisherSearch() {
            var searchInput = document.getElementById("mct-inline-affiliated-publisher-search");
            var dd = document.getElementById("mct-inline-affiliated-publisher-dropdown");
            var statusEl = document.getElementById("mct-inline-affiliated-publisher-status");
            var affiliationField = document.getElementById("mct-inline-affiliated-publisher");
            var memberIdField = document.getElementById("mct-inline-affiliated-publisher-member-id");
            if (!searchInput || !dd || !affiliationField || !memberIdField) {
                return;
            }

            var pubUrl = new URL("actions/publisher-affiliation-search.php", window.location.href).href;
            var timer = null;
            var abortCtl = null;

            function hideDd() {
                dd.style.display = "none";
                dd.innerHTML = "";
            }

            function setStatus(msg) {
                if (statusEl) {
                    statusEl.textContent = msg || "";
                }
            }

            searchInput.addEventListener("input", function () {
                setStatus("");
                var q = String(searchInput.value || "").trim();
                hideDd();
                if (timer) clearTimeout(timer);
                if (abortCtl) {
                    abortCtl.abort();
                    abortCtl = null;
                }
                if (q.length < 2) {
                    return;
                }

                timer = setTimeout(function () {
                    timer = null;
                    if (abortCtl) abortCtl.abort();
                    abortCtl = new AbortController();
                    setStatus("กำลังค้นหา...");
                    fetch(pubUrl + "?q=" + encodeURIComponent(q) + "&limit=25", {
                        signal: abortCtl.signal,
                        credentials: "same-origin"
                    })
                        .then(function (res) {
                            return res.text().then(function (text) {
                                var data = {};
                                try {
                                    data = text ? JSON.parse(text) : {};
                                } catch (e) {
                                    data = {};
                                }
                                return data;
                            });
                        })
                        .then(function (data) {
                            setStatus("");
                            if (!data || data.success !== true || !Array.isArray(data.results)) {
                                hideDd();
                                return;
                            }
                            if (data.results.length === 0) {
                                dd.innerHTML = '<span class="list-group-item text-muted">ไม่พบ Publisher ในฐานข้อมูล</span>';
                                dd.style.display = "block";
                                return;
                            }
                            var html = "";
                            data.results.forEach(function (r, idx) {
                                html += '<button type="button" class="list-group-item list-group-item-action text-start" data-idx="' + idx + '">' +
                                    escapeHtml(String(r.line || r.label || "")) + "</button>";
                            });
                            dd.__rows = data.results;
                            dd.innerHTML = html;
                            dd.style.display = "block";
                        })
                        .catch(function (e) {
                            if (e && e.name === "AbortError") return;
                            setStatus("");
                            hideDd();
                        });
                }, 280);
            });

            dd.addEventListener("click", function (e) {
                var btn = e.target && e.target.closest ? e.target.closest("button[data-idx]") : null;
                if (!btn) return;
                var idx = parseInt(btn.getAttribute("data-idx"), 10);
                var rows = dd.__rows || [];
                if (!rows[idx]) return;
                var row = rows[idx];
                affiliationField.value = String(row.label || "");
                memberIdField.value = row.member_id ? String(row.member_id) : "";
                searchInput.value = "";
                hideDd();
                setStatus("");
            });

            affiliationField.addEventListener("input", function () {
                memberIdField.value = "";
            });

            document.addEventListener("click", function (e) {
                var t = e.target;
                if ((searchInput && searchInput.contains(t)) || (dd && dd.contains(t))) {
                    return;
                }
                hideDd();
            });
        }

        function createInlineAddressRowHtml(addr) {
            inlineAddressRowSeq += 1;
            var rowId = "mct-inline-address-row-" + inlineAddressRowSeq;
            var addressType = String((addr && addr.address_type) || "").trim();
            if (addressType === "") {
                addressType = "ที่อยู่ตามทะเบียน";
            }
            return (
                '<div class="rounded-3 border border-dashed p-2 mct-inline-address-row" data-row-id="' + rowId + '">' +
                '<div class="d-flex justify-content-end mb-2"><button type="button" class="btn btn-sm btn-soft-danger mct-inline-address-remove">ลบที่อยู่นี้</button></div>' +
                '<div class="vstack gap-2">' +
                '<select class="form-select form-select-sm mct-inline-address-type">' +
                '<option value="ที่อยู่ตามทะเบียน"' + (addressType === "ที่อยู่ตามทะเบียน" ? " selected" : "") + '>ที่อยู่ตามทะเบียน</option>' +
                '<option value="ที่อยู่ปัจจุบัน (สำหรับส่งไปรษณีย์)"' + (addressType === "ที่อยู่ปัจจุบัน (สำหรับส่งไปรษณีย์)" ? " selected" : "") + '>ที่อยู่ปัจจุบัน (สำหรับส่งไปรษณีย์)</option>' +
                "</select>" +
                '<input type="text" class="form-control form-control-sm mct-inline-address-street" placeholder="ที่อยู่" value="' + escapeHtml((addr && addr.address_street) || "") + '">' +
                '<div class="position-relative">' +
                '<input type="text" class="form-control form-control-sm mct-inline-address-search" placeholder="ค้นหาที่อยู่จากฐานข้อมูล (ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์)">' +
                '<div class="mct-inline-address-dropdown list-group position-absolute w-100 mt-1 shadow-sm border rounded" style="z-index:1050;max-height:220px;overflow-y:auto;display:none;"></div>' +
                '</div>' +
                '<small class="mct-inline-address-status text-muted"></small>' +
                '<small class="mct-inline-address-error text-danger" style="display:none;"></small>' +
                '<div class="row g-2">' +
                '<div class="col-md-6"><input type="text" class="form-control form-control-sm bg-light mct-inline-address-subdistrict" placeholder="ตำบล/แขวง" value="' + escapeHtml((addr && addr.address_subdistrict) || "") + '" readonly></div>' +
                '<div class="col-md-6"><input type="text" class="form-control form-control-sm bg-light mct-inline-address-district" placeholder="อำเภอ/เขต" value="' + escapeHtml((addr && addr.address_district) || "") + '" readonly></div>' +
                '</div>' +
                '<div class="row g-2">' +
                '<div class="col-md-6"><input type="text" class="form-control form-control-sm bg-light mct-inline-address-province" placeholder="จังหวัด" value="' + escapeHtml((addr && addr.address_province) || "") + '" readonly></div>' +
                '<div class="col-md-6"><input type="text" class="form-control form-control-sm bg-light mct-inline-address-postal" placeholder="รหัสไปรษณีย์" value="' + escapeHtml((addr && addr.address_postal_code) || "") + '" readonly></div>' +
                "</div></div></div>"
            );
        }

        function setupInlineAddressSearchForRow(rowEl) {
            if (!rowEl) return;
            var searchInput = rowEl.querySelector(".mct-inline-address-search");
            var dd = rowEl.querySelector(".mct-inline-address-dropdown");
            var statusEl = rowEl.querySelector(".mct-inline-address-status");
            var errorEl = rowEl.querySelector(".mct-inline-address-error");
            var fldSub = rowEl.querySelector(".mct-inline-address-subdistrict");
            var fldDist = rowEl.querySelector(".mct-inline-address-district");
            var fldProv = rowEl.querySelector(".mct-inline-address-province");
            var fldZip = rowEl.querySelector(".mct-inline-address-postal");
            if (!searchInput || !dd || !fldSub || !fldDist || !fldProv || !fldZip) return;

            var addressSearchUrl = new URL("actions/thailand-address-search.php", window.location.href).href;
            var timer = null;
            var abortCtl = null;
            function hideDd() { dd.style.display = "none"; dd.innerHTML = ""; }
            function setStatus(msg) { if (statusEl) statusEl.textContent = msg || ""; }
            function setErr(msg) {
                if (!errorEl) return;
                errorEl.textContent = msg || "";
                errorEl.style.display = msg ? "block" : "none";
            }

            searchInput.addEventListener("input", function () {
                var q = String(searchInput.value || "").trim();
                setErr(""); setStatus(""); hideDd();
                if (timer) clearTimeout(timer);
                if (abortCtl) { abortCtl.abort(); abortCtl = null; }
                if (q.length < 2) return;
                timer = setTimeout(function () {
                    timer = null;
                    if (abortCtl) abortCtl.abort();
                    abortCtl = new AbortController();
                    setStatus("กำลังค้นหา...");
                    fetch(addressSearchUrl + "?q=" + encodeURIComponent(q) + "&limit=25", { signal: abortCtl.signal, credentials: "same-origin" })
                        .then(function (res) {
                            return res.text().then(function (text) {
                                var data = {};
                                try { data = text ? JSON.parse(text) : {}; } catch (e) { data = {}; }
                                return { ok: res.ok, data: data };
                            });
                        })
                        .then(function (pack) {
                            setStatus("");
                            if (!pack.ok || !pack.data || pack.data.success !== true) {
                                setErr((pack.data && pack.data.message) ? pack.data.message : "ค้นหาที่อยู่ไม่สำเร็จ");
                                hideDd();
                                return;
                            }
                            var rows = pack.data.results || [];
                            if (rows.length === 0) {
                                dd.innerHTML = '<span class="list-group-item text-muted">ไม่พบข้อมูล</span>';
                                dd.style.display = "block";
                                return;
                            }
                            dd.innerHTML = rows.map(function (r, idx) {
                                var line = escapeHtml(r.subdistrict || "") + " » " + escapeHtml(r.district || "") + " » " + escapeHtml(r.province || "") + " " + escapeHtml(r.postal_code || "");
                                return '<button type="button" class="list-group-item list-group-item-action text-start" data-idx="' + idx + '">' + line + "</button>";
                            }).join("");
                            dd.__rows = rows;
                            dd.style.display = "block";
                        })
                        .catch(function (e) {
                            if (e && e.name === "AbortError") return;
                            setStatus(""); setErr("เชื่อมต่อเซิร์ฟเวอร์ไม่ได้"); hideDd();
                        });
                }, 320);
            });

            dd.addEventListener("click", function (e) {
                var btn = e.target && e.target.closest ? e.target.closest("button[data-idx]") : null;
                if (!btn || !dd.contains(btn)) return;
                var rows = dd.__rows || [];
                var idx = parseInt(btn.getAttribute("data-idx"), 10);
                if (!rows[idx]) return;
                var r = rows[idx];
                fldSub.value = r.subdistrict || "";
                fldDist.value = r.district || "";
                fldProv.value = r.province || "";
                fldZip.value = r.postal_code || "";
                searchInput.value = "";
                setErr("");
                hideDd();
            });
        }

        function bindInlineAddressRows() {
            var rowsWrap = document.getElementById("mct-inline-address-rows");
            if (!rowsWrap) return;
            var rows = rowsWrap.querySelectorAll(".mct-inline-address-row");
            rows.forEach(function (rowEl) {
                if (rowEl.dataset.bound === "1") return;
                rowEl.dataset.bound = "1";
                setupInlineAddressSearchForRow(rowEl);
                var removeBtn = rowEl.querySelector(".mct-inline-address-remove");
                if (removeBtn) {
                    removeBtn.addEventListener("click", function () {
                        rowEl.remove();
                        if (rowsWrap.querySelectorAll(".mct-inline-address-row").length === 0) {
                            rowsWrap.insertAdjacentHTML("beforeend", createInlineAddressRowHtml({}));
                            bindInlineAddressRows();
                        }
                    });
                }
            });

            if (!inlineAddressDocBound) {
                inlineAddressDocBound = true;
                document.addEventListener("click", function (e) {
                    var t = e.target;
                    var dropdowns = document.querySelectorAll(".mct-inline-address-dropdown");
                    dropdowns.forEach(function (box) {
                        var row = box.closest(".mct-inline-address-row");
                        if (!row) return;
                        var input = row.querySelector(".mct-inline-address-search");
                        if (input && (input.contains(t) || box.contains(t))) return;
                        box.style.display = "none";
                    });
                });
            }
        }

        function collectWriterInlineValues() {
            return {
                writer_type: String($("#mct-inline-writer-type").val() || "").trim(),
                rightsholder_type: String((currentMember && currentMember.rightsholder_type) || "").trim(),
                genre: String($("#mct-inline-genre").val() || "").trim(),
                creative_role_melody: $("#mct-inline-role-melody").is(":checked") ? 1 : 0,
                creative_role_lyrics: $("#mct-inline-role-lyrics").is(":checked") ? 1 : 0,
                creative_role_arrangement: $("#mct-inline-role-arrangement").is(":checked") ? 1 : 0,
                affiliated_publisher: String($("#mct-inline-affiliated-publisher").val() || "").trim(),
                affiliated_publisher_member_id: String($("#mct-inline-affiliated-publisher-member-id").val() || "").trim()
            };
        }

        function beginWriterEdit() {
            writerEditing = true;
            renderWriterInlineForm(getCurrentWriter());
            setupWriterPublisherSearch();
            toggleWriterEditButton(false);
        }

        function endWriterEdit() {
            writerEditing = false;
            setWriterReadOnly(getCurrentWriter());
            toggleWriterEditButton(false);
        }

        function saveWriterInline() {
            if (!currentMember || !currentMember.member_code) {
                showAlert("danger", "ไม่พบ member_code สำหรับบันทึกข้อมูลนักแต่งเพลง");
                return;
            }
            var payload = collectWriterInlineValues();
            if (!payload.writer_type || !payload.rightsholder_type) {
                showAlert("danger", "กรุณาเลือกประเภทนักแต่งและประเภทผู้ทรงสิทธิ");
                return;
            }

            toggleWriterEditButton(true);
            $.ajax({
                url: API_URL,
                method: "POST",
                dataType: "json",
                data: Object.assign({}, payload, {
                    action: "update_writer",
                    member_code: String(currentMember.member_code || "").trim()
                })
            })
                .done(function (res) {
                    if (!res || res.success !== true) {
                        showAlert("danger", (res && res.message) ? res.message : "บันทึกข้อมูลนักแต่งเพลงไม่สำเร็จ");
                        toggleWriterEditButton(false);
                        return;
                    }
                    var writer = res.writer || payload;
                    currentMember.writer_type = writer.writer_type;
                    currentMember.rightsholder_type = writer.rightsholder_type;
                    currentMember.genre = writer.genre;
                    currentMember.creative_role_melody = writer.creative_role_melody;
                    currentMember.creative_role_lyrics = writer.creative_role_lyrics;
                    currentMember.creative_role_arrangement = writer.creative_role_arrangement;
                    currentMember.affiliated_publisher = writer.affiliated_publisher;
                    currentMember.affiliated_publisher_member_id = writer.affiliated_publisher_member_id || null;

                    if (els.subtitle) {
                        var wt = String(currentMember.writer_type || "").trim();
                        var rt = String(currentMember.rightsholder_type || "").trim();
                        els.subtitle.textContent = [wt, rt].filter(Boolean).join(" · ") || "—";
                    }
                    endWriterEdit();
                    showWriterSaveSuccessAlert((res && res.message) ? res.message : "บันทึกข้อมูลนักแต่งเพลงเรียบร้อยแล้ว");
                    reloadAuditLogs();
                })
                .fail(function (xhr) {
                    var msg = "บันทึกข้อมูลนักแต่งเพลงไม่สำเร็จ";
                    if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                        msg = xhr.responseJSON.message;
                    }
                    showAlert("danger", msg);
                    toggleWriterEditButton(false);
                });
        }

        function initWriterInlineEditing() {
            var editBtn = document.getElementById("mct-btn-edit-writer");
            var cancelBtn = document.getElementById("mct-btn-cancel-writer");
            if (!editBtn || !cancelBtn) {
                return;
            }
            editBtn.addEventListener("click", function (event) {
                event.preventDefault();
                if (!writerEditing) {
                    beginWriterEdit();
                    return;
                }
                saveWriterInline();
            });
            cancelBtn.addEventListener("click", function (event) {
                event.preventDefault();
                endWriterEdit();
            });
        }

        function beginContactEdit(section, resetValues) {
            if (!currentMember) return;
            contactEditing[section] = true;
            if (section === "email") {
                var rows = (currentMember.emails || []).map(function (r) { return String(r.email || "").trim(); }).filter(Boolean);
                if (rows.length === 0) rows = [""];
                $("#mct-contact-emails").html(
                    '<div id="mct-inline-email-rows" class="vstack gap-2"></div>' +
                    '<a href="#" class="btn btn-sm btn-soft-success mt-2" id="mct-inline-email-add">+ เพิ่มอีเมล</a>'
                );
                var emailWrap = document.getElementById("mct-inline-email-rows");
                rows.forEach(function (em) {
                    var rowEl = document.createElement("div");
                    rowEl.className = "d-flex gap-2";
                    rowEl.innerHTML =
                        '<input type="email" class="form-control form-control-sm mct-inline-email-input" placeholder="demo@mail.com" value="' + escapeHtml(em) + '">' +
                        '<button type="button" class="btn btn-sm btn-soft-danger mct-inline-email-remove">ลบ</button>';
                    emailWrap.appendChild(rowEl);
                });
                $("#mct-inline-email-add").onClick = null;
                document.getElementById("mct-inline-email-add").addEventListener("click", function (e) {
                    e.preventDefault();
                    var rowEl = document.createElement("div");
                    rowEl.className = "d-flex gap-2";
                    rowEl.innerHTML =
                        '<input type="email" class="form-control form-control-sm mct-inline-email-input" placeholder="demo@mail.com" value="">' +
                        '<button type="button" class="btn btn-sm btn-soft-danger mct-inline-email-remove">ลบ</button>';
                    emailWrap.appendChild(rowEl);
                    bindInlineRemoveButtons("mct-inline-email-remove");
                });
                bindInlineRemoveButtons("mct-inline-email-remove");
            } else if (section === "phone") {
                var phones = (currentMember.phones || []).map(function (r) {
                    var n = String(r.phone_number || "").trim();
                    var x = String(r.phone_ext || "").trim();
                    return n ? { number: n, ext: x } : null;
                }).filter(Boolean);
                if (phones.length === 0) phones = [{ number: "", ext: "" }];
                $("#mct-contact-phones").html(
                    '<div id="mct-inline-phone-rows" class="vstack gap-2"></div>' +
                    '<a href="#" class="btn btn-sm btn-soft-success mt-2" id="mct-inline-phone-add">+ เพิ่มเบอร์โทร</a>'
                );
                var phoneWrap = document.getElementById("mct-inline-phone-rows");
                phones.forEach(function (ph) {
                    var rowEl = document.createElement("div");
                    rowEl.className = "row g-2";
                    rowEl.innerHTML =
                        '<div class="col-md-7"><input type="text" class="form-control form-control-sm mct-inline-phone-number" placeholder="02-0000000" value="' + escapeHtml(ph.number || "") + '"></div>' +
                        '<div class="col-md-3"><input type="text" class="form-control form-control-sm mct-inline-phone-ext" placeholder="ต่อ" value="' + escapeHtml(ph.ext || "") + '"></div>' +
                        '<div class="col-md-2 d-grid"><button type="button" class="btn btn-sm btn-soft-danger mct-inline-phone-remove">ลบ</button></div>';
                    phoneWrap.appendChild(rowEl);
                });
                document.getElementById("mct-inline-phone-add").addEventListener("click", function (e) {
                    e.preventDefault();
                    var rowEl = document.createElement("div");
                    rowEl.className = "row g-2";
                    rowEl.innerHTML =
                        '<div class="col-md-7"><input type="text" class="form-control form-control-sm mct-inline-phone-number" placeholder="02-0000000" value=""></div>' +
                        '<div class="col-md-3"><input type="text" class="form-control form-control-sm mct-inline-phone-ext" placeholder="ต่อ" value=""></div>' +
                        '<div class="col-md-2 d-grid"><button type="button" class="btn btn-sm btn-soft-danger mct-inline-phone-remove">ลบ</button></div>';
                    phoneWrap.appendChild(rowEl);
                    bindInlineRemoveButtons("mct-inline-phone-remove");
                });
                bindInlineRemoveButtons("mct-inline-phone-remove");
            } else if (section === "mobile") {
                var mobiles = (currentMember.mobiles || []).map(function (r) { return String(r.mobile_number || "").trim(); }).filter(Boolean);
                if (mobiles.length === 0) mobiles = [""];
                $("#mct-contact-mobiles").html(
                    '<div id="mct-inline-mobile-rows" class="vstack gap-2"></div>' +
                    '<a href="#" class="btn btn-sm btn-soft-success mt-2" id="mct-inline-mobile-add">+ เพิ่มมือถือ</a>'
                );
                var mobileWrap = document.getElementById("mct-inline-mobile-rows");
                mobiles.forEach(function (mob) {
                    var rowEl = document.createElement("div");
                    rowEl.className = "d-flex gap-2";
                    rowEl.innerHTML =
                        '<input type="text" class="form-control form-control-sm mct-inline-mobile-input" placeholder="08x-xxx-xxxx" value="' + escapeHtml(mob) + '">' +
                        '<button type="button" class="btn btn-sm btn-soft-danger mct-inline-mobile-remove">ลบ</button>';
                    mobileWrap.appendChild(rowEl);
                });
                document.getElementById("mct-inline-mobile-add").addEventListener("click", function (e) {
                    e.preventDefault();
                    var rowEl = document.createElement("div");
                    rowEl.className = "d-flex gap-2";
                    rowEl.innerHTML =
                        '<input type="text" class="form-control form-control-sm mct-inline-mobile-input" placeholder="08x-xxx-xxxx" value="">' +
                        '<button type="button" class="btn btn-sm btn-soft-danger mct-inline-mobile-remove">ลบ</button>';
                    mobileWrap.appendChild(rowEl);
                    bindInlineRemoveButtons("mct-inline-mobile-remove");
                });
                bindInlineRemoveButtons("mct-inline-mobile-remove");
            } else if (section === "address") {
                var addrList = [];
                if (!resetValues) {
                    if (Array.isArray(currentMember.addresses) && currentMember.addresses.length > 0) {
                        addrList = currentMember.addresses;
                    } else if (currentMember.address) {
                        addrList = [currentMember.address];
                    }
                }
                if (addrList.length === 0) {
                    addrList = [{}];
                }
                $("#mct-address-text").html('<div id="mct-inline-address-rows" class="vstack gap-3"></div>');
                var rowsWrap = document.getElementById("mct-inline-address-rows");
                if (rowsWrap) {
                    addrList.forEach(function (row) {
                        rowsWrap.insertAdjacentHTML("beforeend", createInlineAddressRowHtml(row));
                    });
                }
                var addressActions = document.getElementById("mct-address-inline-actions");
                if (addressActions) {
                    addressActions.innerHTML = '<a href="#" class="btn btn-sm btn-soft-success w-100 mt-2" id="mct-inline-address-add">+ เพิ่มที่อยู่</a>';
                }
                bindInlineAddressRows();
                var addAddressBtn = document.getElementById("mct-inline-address-add");
                if (addAddressBtn) {
                    addAddressBtn.addEventListener("click", function (e) {
                        e.preventDefault();
                        var wrap = document.getElementById("mct-inline-address-rows");
                        if (!wrap) return;
                        wrap.insertAdjacentHTML("beforeend", createInlineAddressRowHtml({}));
                        bindInlineAddressRows();
                    });
                }
            } else if (section === "social") {
                var soc = currentMember.social || {};
                $("#mct-social-line").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-line" value="' + escapeHtml(soc.line_id || "") + '">');
                $("#mct-social-fb").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-fb" value="' + escapeHtml(soc.facebook || "") + '">');
                $("#mct-social-youtube").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-youtube" value="' + escapeHtml(soc.youtube || "") + '">');
                $("#mct-social-tiktok").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-tiktok" value="' + escapeHtml(soc.tiktok || "") + '">');
                $("#mct-social-instagram").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-instagram" value="' + escapeHtml(soc.instagram || "") + '">');
                $("#mct-social-x").html('<input type="text" class="form-control form-control-sm" id="mct-inline-social-x" value="' + escapeHtml(soc.x_twitter || "") + '">');
                $("#mct-social-note").html('<textarea class="form-control form-control-sm" id="mct-inline-social-note" rows="3">' + escapeHtml(soc.contact_note || "") + "</textarea>");
            }
            syncContactButtons(section, false);
        }

        function bindInlineRemoveButtons(className) {
            var buttons = document.querySelectorAll("." + className);
            buttons.forEach(function (btn) {
                btn.onclick = function () {
                    var row = btn.closest(".d-flex, .row");
                    if (row && row.parentNode) {
                        row.parentNode.removeChild(row);
                    }
                };
            });
        }

        function endContactEdit(section) {
            contactEditing[section] = false;
            if (!currentMember) return;
            if (section === "email") {
                renderContactEmails(currentMember.emails || []);
            } else if (section === "phone") {
                renderContactPhones(currentMember.phones || []);
            } else if (section === "mobile") {
                renderContactMobiles(currentMember.mobiles || []);
            } else if (section === "address") {
                renderAddresses(currentMember.addresses || currentMember.address);
                var addressActions = document.getElementById("mct-address-inline-actions");
                if (addressActions) {
                    addressActions.innerHTML = "";
                }
            } else if (section === "social") {
                var soc = currentMember.social || {};
                setText("mct-social-line", soc.line_id);
                setText("mct-social-fb", soc.facebook);
                setText("mct-social-youtube", soc.youtube);
                setText("mct-social-tiktok", soc.tiktok);
                setText("mct-social-instagram", soc.instagram);
                setText("mct-social-x", soc.x_twitter);
                setText("mct-social-note", soc.contact_note);
            }
            syncContactButtons(section, false);
        }

        function syncContactButtons(section, loading) {
            var editBtn = $("#mct-btn-" + section + "-edit");
            var cancelBtn = $("#mct-btn-" + section + "-cancel");
            var sectionLabels = {
                email: "Edit อีเมล",
                phone: "Edit โทรศัพท์ (สำนักงาน)",
                mobile: "Edit มือถือ",
                address: "Edit ที่อยู่",
                social: "Edit โซเชียล / อื่น ๆ"
            };
            var defaultLabel = sectionLabels[section] || "Edit";
            if (contactEditing[section]) {
                editBtn.html(loading
                    ? '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>กำลังบันทึก...'
                    : '<i class="ri-save-line align-bottom me-1"></i>บันทึกข้อมูล');
                cancelBtn.html('<i class="ri-close-line align-bottom me-1"></i>ยกเลิก');
                cancelBtn.removeClass("d-none");
            } else {
                editBtn.html('<i class="ri-edit-2-line align-bottom me-1"></i>' + defaultLabel);
                cancelBtn.addClass("d-none");
            }
        }

        function saveContactSection(section) {
            if (!currentMember || !currentMember.member_code) {
                showContactTabAlert("danger", "ไม่พบ member_code สำหรับบันทึกข้อมูลติดต่อ");
                return;
            }
            var data = {
                action: "update_contact",
                contact_section: section,
                member_code: String(currentMember.member_code || "").trim()
            };
            if (section === "email") {
                var emailInputs = document.querySelectorAll(".mct-inline-email-input");
                var emails = [];
                emailInputs.forEach(function (el) {
                    var v = String((el && el.value) || "").trim();
                    if (v) emails.push(v);
                });
                data.emails_text = emails.join("\n");
            } else if (section === "phone") {
                var phoneNumberInputs = document.querySelectorAll(".mct-inline-phone-number");
                var phoneExtInputs = document.querySelectorAll(".mct-inline-phone-ext");
                var phoneLines = [];
                for (var i = 0; i < phoneNumberInputs.length; i++) {
                    var num = String((phoneNumberInputs[i] && phoneNumberInputs[i].value) || "").trim();
                    var ext = String((phoneExtInputs[i] && phoneExtInputs[i].value) || "").trim();
                    if (!num) continue;
                    phoneLines.push(ext ? (num + "|" + ext) : num);
                }
                data.phones_text = phoneLines.join("\n");
            } else if (section === "mobile") {
                var mobileInputs = document.querySelectorAll(".mct-inline-mobile-input");
                var mobileLines = [];
                mobileInputs.forEach(function (el) {
                    var v = String((el && el.value) || "").trim();
                    if (v) mobileLines.push(v);
                });
                data.mobiles_text = mobileLines.join("\n");
            } else if (section === "address") {
                var addressRows = [];
                var rowEls = document.querySelectorAll(".mct-inline-address-row");
                rowEls.forEach(function (rowEl) {
                    var addressType = String((rowEl.querySelector(".mct-inline-address-type") || {}).value || "").trim();
                    var street = String((rowEl.querySelector(".mct-inline-address-street") || {}).value || "").trim();
                    var sub = String((rowEl.querySelector(".mct-inline-address-subdistrict") || {}).value || "").trim();
                    var dist = String((rowEl.querySelector(".mct-inline-address-district") || {}).value || "").trim();
                    var prov = String((rowEl.querySelector(".mct-inline-address-province") || {}).value || "").trim();
                    var post = String((rowEl.querySelector(".mct-inline-address-postal") || {}).value || "").trim();
                    if (!street && !sub && !dist && !prov && !post) {
                        return;
                    }
                    addressRows.push({
                        address_type: addressType || "ที่อยู่ตามทะเบียน",
                        address_street: street,
                        address_subdistrict: sub,
                        address_district: dist,
                        address_province: prov,
                        address_postal_code: post
                    });
                });
                data.address_rows_json = JSON.stringify(addressRows);
            } else if (section === "social") {
                data.line_id = String($("#mct-inline-social-line").val() || "").trim();
                data.facebook = String($("#mct-inline-social-fb").val() || "").trim();
                data.youtube = String($("#mct-inline-social-youtube").val() || "").trim();
                data.tiktok = String($("#mct-inline-social-tiktok").val() || "").trim();
                data.instagram = String($("#mct-inline-social-instagram").val() || "").trim();
                data.x_twitter = String($("#mct-inline-social-x").val() || "").trim();
                data.contact_note = String($("#mct-inline-social-note").val() || "").trim();
            }

            syncContactButtons(section, true);
            $.ajax({
                url: API_URL,
                method: "POST",
                dataType: "json",
                data: data
            }).done(function (res) {
                if (!res || res.success !== true) {
                    showContactTabAlert("danger", (res && res.message) ? res.message : "บันทึกข้อมูลติดต่อไม่สำเร็จ");
                    syncContactButtons(section, false);
                    return;
                }
                if (section === "email") {
                    var lines = String(data.emails_text || "").replace(/\r/g, "").split("\n");
                    currentMember.emails = lines.map(function (line, i) {
                        var em = String(line || "").trim();
                        return em ? { email: em, sort_order: i } : null;
                    }).filter(Boolean);
                } else if (section === "phone") {
                    var phoneLines = String(data.phones_text || "").replace(/\r/g, "").split("\n");
                    currentMember.phones = phoneLines.map(function (line, i) {
                        var s = String(line || "").trim();
                        if (!s) return null;
                        var parts = s.split("|");
                        var p = String(parts[0] || "").trim();
                        var x = String(parts[1] || "").trim();
                        if (!p) return null;
                        return { phone_number: p, phone_ext: x, sort_order: i };
                    }).filter(Boolean);
                } else if (section === "mobile") {
                    var mobLines = String(data.mobiles_text || "").replace(/\r/g, "").split("\n");
                    currentMember.mobiles = mobLines.map(function (line, i) {
                        var m = String(line || "").trim();
                        return m ? { mobile_number: m, sort_order: i } : null;
                    }).filter(Boolean);
                } else if (section === "address") {
                    var parsedRows = [];
                    try {
                        parsedRows = JSON.parse(data.address_rows_json || "[]");
                    } catch (e) {
                        parsedRows = [];
                    }
                    currentMember.addresses = Array.isArray(parsedRows) ? parsedRows : [];
                    currentMember.address = currentMember.addresses.length > 0 ? currentMember.addresses[0] : null;
                } else if (section === "social") {
                    currentMember.social = {
                        line_id: data.line_id,
                        facebook: data.facebook,
                        youtube: data.youtube,
                        tiktok: data.tiktok,
                        instagram: data.instagram,
                        x_twitter: data.x_twitter,
                        contact_note: data.contact_note
                    };
                }
                endContactEdit(section);
                showContactTabAlert("success", (res && res.message) ? res.message : "บันทึกข้อมูลติดต่อเรียบร้อยแล้ว");
                reloadAuditLogs();
            }).fail(function (xhr) {
                var msg = "บันทึกข้อมูลติดต่อไม่สำเร็จ";
                if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
                    msg = xhr.responseJSON.message;
                }
                showContactTabAlert("danger", msg);
                syncContactButtons(section, false);
            });
        }

        function initContactInlineEditing() {
            ["email", "phone", "mobile", "address", "social"].forEach(function (section) {
                var editBtn = document.getElementById("mct-btn-" + section + "-edit");
                var addBtn = document.getElementById("mct-btn-" + section + "-add");
                var cancelBtn = document.getElementById("mct-btn-" + section + "-cancel");
                if (!editBtn || !cancelBtn) return;
                editBtn.addEventListener("click", function (event) {
                    event.preventDefault();
                    if (!contactEditing[section]) {
                        beginContactEdit(section, false);
                        return;
                    }
                    saveContactSection(section);
                });
                if (addBtn) {
                    addBtn.addEventListener("click", function (event) {
                        event.preventDefault();
                        if (section === "address") {
                            beginContactEdit(section, true);
                            return;
                        }
                        if (!contactEditing[section]) {
                            beginContactEdit(section, false);
                        }
                    });
                }
                cancelBtn.addEventListener("click", function (event) {
                    event.preventDefault();
                    endContactEdit(section);
                });
            });
        }

        function telDialHref(num) {
            var s = String(num || "").trim();
            if (!s) {
                return "#";
            }
            var dial = s.replace(/[^\d+#*]/g, "");
            return dial ? "tel:" + dial : "#";
        }

        function renderContactEmails(rows) {
            var el = document.getElementById("mct-contact-emails");
            if (!el) {
                return;
            }
            if (!rows || rows.length === 0) {
                el.innerHTML = '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
                return;
            }
            var html = rows
                .map(function (row) {
                    var em = String(row.email || "").trim();
                    if (!em) {
                        return "";
                    }
                    var href = encodeURI("mailto:" + em);
                    return (
                        '<div class="d-flex align-items-start gap-2">' +
                        '<i class="ri-mail-line text-primary mt-1 fs-15 flex-shrink-0"></i>' +
                        '<a href="' +
                        href +
                        '" class="link-primary link-offset-2 text-break">' +
                        escapeHtml(em) +
                        "</a></div>"
                    );
                })
                .filter(Boolean);
            el.innerHTML =
                html.length > 0
                    ? html.join("")
                    : '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
        }

        function renderContactPhones(rows) {
            var el = document.getElementById("mct-contact-phones");
            if (!el) {
                return;
            }
            if (!rows || rows.length === 0) {
                el.innerHTML = '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
                return;
            }
            var html = rows
                .map(function (row) {
                    var n = String(row.phone_number || "").trim();
                    if (!n) {
                        return "";
                    }
                    var ext = String(row.phone_ext || "").trim();
                    var href = telDialHref(n);
                    return (
                        '<div class="d-flex align-items-start gap-2 flex-wrap">' +
                        '<i class="ri-phone-fill text-info mt-1 fs-15 flex-shrink-0"></i>' +
                        '<span class="text-break">' +
                        (href !== "#"
                            ? '<a href="' + href + '" class="link-body fw-medium">' + escapeHtml(n) + "</a>"
                            : '<span class="fw-medium">' + escapeHtml(n) + "</span>") +
                        (ext
                            ? '<span class="text-muted ms-2 small"><span class="badge bg-light text-muted border fw-normal">ต่อ ' +
                              escapeHtml(ext) +
                              "</span></span>"
                            : "") +
                        "</span></div>"
                    );
                })
                .filter(Boolean);
            el.innerHTML =
                html.length > 0
                    ? html.join("")
                    : '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
        }

        function renderContactMobiles(rows) {
            var el = document.getElementById("mct-contact-mobiles");
            if (!el) {
                return;
            }
            if (!rows || rows.length === 0) {
                el.innerHTML = '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
                return;
            }
            var html = rows
                .map(function (row) {
                    var n = String(row.mobile_number || "").trim();
                    if (!n) {
                        return "";
                    }
                    var href = telDialHref(n);
                    return (
                        '<div class="d-flex align-items-start gap-2">' +
                        '<i class="ri-smartphone-line text-success mt-1 fs-15 flex-shrink-0"></i>' +
                        (href !== "#"
                            ? '<a href="' + href + '" class="link-success fw-medium text-break">' + escapeHtml(n) + "</a>"
                            : '<span class="fw-medium text-break">' + escapeHtml(n) + "</span>") +
                        "</div>"
                    );
                })
                .filter(Boolean);
            el.innerHTML =
                html.length > 0
                    ? html.join("")
                    : '<span class="text-muted small fst-italic">ยังไม่มีข้อมูล</span>';
        }

        function renderAddresses(addrOrList) {
            var el = document.getElementById("mct-address-text");
            if (!el) {
                return;
            }
            var list = [];
            if (Array.isArray(addrOrList)) {
                list = addrOrList;
            } else if (addrOrList && typeof addrOrList === "object") {
                list = [addrOrList];
            }
            if (!list || list.length === 0) {
                el.textContent = "—";
                return;
            }
            var html = list
                .map(function (addr) {
                    var addressType = String(addr.address_type || "").trim();
                    var street = String(addr.address_street || "").trim();
                    var sub = String(addr.address_subdistrict || "").trim();
                    var dist = String(addr.address_district || "").trim();
                    var prov = String(addr.address_province || "").trim();
                    var post = String(addr.address_postal_code || "").trim();
                    var mid = [sub, dist, prov].filter(Boolean).join(" ");
                    var parts = [];
                    if (street) parts.push(street);
                    if (mid) parts.push(mid);
                    if (post) parts.push("รหัสไปรษณีย์ " + post);
                    if (parts.length === 0) return "";
                    return '<div class="mb-2 pb-2 border-bottom border-light-subtle">' +
                        (addressType ? '<span class="badge bg-light text-muted border mb-1">' + escapeHtml(addressType) + "</span>" : "") +
                        parts.map(function (p) { return '<span class="d-block">' + escapeHtml(p) + "</span>"; }).join("") +
                        "</div>";
                })
                .filter(Boolean)
                .join("");
            el.innerHTML = html !== "" ? html : "—";
        }

        function publicHref(path) {
            var p = String(path || "").trim();
            if (!p) {
                return "";
            }
            if (/^https?:\/\//i.test(p)) {
                return p;
            }
            var b = String(BASE_PATH || "").replace(/\/$/, "");
            var rel = p.replace(/^\/+/, "");
            return (b ? b + "/" : "") + rel;
        }

        function stripPenIpiCopiedFromMain(ipiNameNo, ipiBaseNo, memberMeta) {
            var rhs = String((memberMeta && memberMeta.rightsholder_type) || "");
            var name = String(ipiNameNo || "").trim();
            var base = String(ipiBaseNo || "").trim();
            if (/Publisher|ผู้พิมพ์ผู้โฆษณา/i.test(rhs)) {
                return { ipiNameNo: name, ipiBaseNo: base };
            }
            var mainName = String((memberMeta && memberMeta.ipi_name_no) || "").replace(/\D+/g, "").trim();
            var mainBase = String((memberMeta && memberMeta.ipi_base_no) || "").trim().toUpperCase();
            if (mainName && name.replace(/\D+/g, "") === mainName) {
                name = "";
            }
            if (mainBase && base.toUpperCase() === mainBase) {
                base = "";
            }
            return { ipiNameNo: name, ipiBaseNo: base };
        }

        function renderPenNames(rows, memberMeta) {
            var tbody = document.getElementById("mct-pen-names-body");
            if (!tbody) {
                return;
            }
            if (!rows || rows.length === 0) {
                tbody.innerHTML =
                    '<tr><td colspan="5" class="text-muted small fst-italic">ยังไม่มีข้อมูล</td></tr>';
                return;
            }
            var html = rows
                .map(function (row) {
                    var th = String(row.pen_name_local || "").trim();
                    var en = String(row.pen_name_eng || "").trim();
                    var internalNo = String(row.internal_no_mis || "").trim();
                    var stripped = stripPenIpiCopiedFromMain(row.ipi_name_no, row.ipi_base_no, memberMeta);
                    var ipiNameNo = stripped.ipiNameNo;
                    var ipiBaseNo = stripped.ipiBaseNo;
                    if (!th && !en && !internalNo && !ipiNameNo && !ipiBaseNo) {
                        return "";
                    }
                    return (
                        "<tr><td class=\"text-break font-monospace user-select-all\">" +
                        escapeHtml(internalNo || "—") +
                        '</td><td class="text-break font-monospace user-select-all">' +
                        escapeHtml(ipiNameNo || "—") +
                        '</td><td class="text-break font-monospace user-select-all">' +
                        escapeHtml(ipiBaseNo || "—") +
                        '</td><td class="text-break">' +
                        escapeHtml(th || "—") +
                        '</td><td class="text-break">' +
                        escapeHtml(en || "—") +
                        "</td></tr>"
                    );
                })
                .filter(Boolean);
            tbody.innerHTML =
                html.length > 0
                    ? html.join("")
                    : '<tr><td colspan="5" class="text-muted small fst-italic">ยังไม่มีข้อมูล</td></tr>';
        }

        function renderPenNamesEditRows(rows, memberMeta) {
            var tbody = document.getElementById("mct-pen-names-body");
            if (!tbody) return;
            var list = Array.isArray(rows) ? rows.slice() : [];
            if (list.length === 0) {
                list = [{ internal_no_mis: "", ipi_name_no: "", ipi_base_no: "", pen_name_local: "", pen_name_eng: "" }];
            }
            var html = list.map(function (row) {
                var internalNo = String(row.internal_no_mis || "").replace(/\D+/g, "").trim();
                var stripped = stripPenIpiCopiedFromMain(row.ipi_name_no, row.ipi_base_no, memberMeta);
                var ipiNameNo = String(stripped.ipiNameNo || "").replace(/\D+/g, "").trim();
                var ipiBaseNo = String(stripped.ipiBaseNo || "").trim();
                return (
                    "<tr>" +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-pen-internal-no font-monospace" value="' + escapeHtml(internalNo) + '" placeholder="Internal No." oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-pen-ipi-name-no font-monospace" value="' + escapeHtml(ipiNameNo) + '" placeholder="IPI Name No ของนามปากกา" oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-pen-ipi-base-no font-monospace" value="' + escapeHtml(ipiBaseNo) + '" placeholder="IPI Base No. ของนามปากกา"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-pen-name-local" value="' + escapeHtml(String(row.pen_name_local || "")) + '" placeholder="ชื่อนามปากกา (ไทย)"></td>' +
                    '<td><div class="d-flex gap-2"><input type="text" class="form-control form-control-sm mct-pen-name-eng" value="' + escapeHtml(String(row.pen_name_eng || "")) + '" placeholder="ชื่อนามปากกา (English)"><button type="button" class="btn btn-sm btn-soft-danger mct-pen-row-remove">ลบ</button></div></td>' +
                    "</tr>"
                );
            }).join("");
            tbody.innerHTML = html;
            bindPenRowRemoveButtons(memberMeta);
        }

        function bindPenRowRemoveButtons(memberMeta) {
            var tbody = document.getElementById("mct-pen-names-body");
            if (!tbody) return;
            var removeButtons = tbody.querySelectorAll(".mct-pen-row-remove");
            removeButtons.forEach(function (btn) {
                btn.onclick = function () {
                    var tr = btn.closest("tr");
                    if (tr) tr.remove();
                    if (!tbody.querySelector("tr")) {
                        renderPenNamesEditRows([], memberMeta);
                    }
                }
            });
        }

        function collectPenRowsFromEditTable() {
            var tbody = document.getElementById("mct-pen-names-body");
            if (!tbody) return [];
            var rows = [];
            var trList = tbody.querySelectorAll("tr");
            trList.forEach(function (tr) {
                var internalNoMis = String((tr.querySelector(".mct-pen-internal-no") || {}).value || "").replace(/\D+/g, "").trim();
                var ipiNameNo = String((tr.querySelector(".mct-pen-ipi-name-no") || {}).value || "").replace(/\D+/g, "").trim();
                var ipiBaseNo = String((tr.querySelector(".mct-pen-ipi-base-no") || {}).value || "").trim();
                var stripped = stripPenIpiCopiedFromMain(ipiNameNo, ipiBaseNo, currentMember || {});
                ipiNameNo = stripped.ipiNameNo.replace(/\D+/g, "").trim();
                ipiBaseNo = String(stripped.ipiBaseNo || "").trim();
                var localName = String((tr.querySelector(".mct-pen-name-local") || {}).value || "").trim();
                var engName = String((tr.querySelector(".mct-pen-name-eng") || {}).value || "").trim();
                if (!localName && !engName && !internalNoMis && !ipiNameNo && !ipiBaseNo) return;
                rows.push({
                    internal_no_mis: internalNoMis,
                    ipi_name_no: ipiNameNo,
                    ipi_base_no: ipiBaseNo,
                    name_type: "PP",
                    pen_name_local: localName,
                    pen_name_eng: engName
                });
            });
            return rows;
        }

        function togglePenButtons(loading) {
            var editBtn = document.getElementById("mct-btn-pen-edit");
            var addBtn = document.getElementById("mct-btn-pen-add");
            var cancelBtn = document.getElementById("mct-btn-pen-cancel");
            if (!editBtn || !addBtn || !cancelBtn) return;
            if (penEditing) {
                editBtn.innerHTML = loading
                    ? '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>กำลังบันทึก...'
                    : '<i class="ri-save-line align-bottom me-1"></i>บันทึกข้อมูล';
                addBtn.innerHTML = '<i class="ri-add-line align-bottom me-1"></i>เพิ่มนามปากกา';
                addBtn.classList.remove("d-none");
                cancelBtn.classList.remove("d-none");
            } else {
                editBtn.innerHTML = '<i class="ri-edit-2-line align-bottom me-1"></i>แก้ไขนามปากกา';
                addBtn.innerHTML = '<i class="ri-add-line align-bottom me-1"></i>เพิ่มนามปากกา';
                addBtn.classList.add("d-none");
                cancelBtn.classList.add("d-none");
            }
        }

        function beginPenEdit(addBlankRow) {
            penEditing = true;
            if (addBlankRow) {
                renderPenNamesEditRows([], currentMember || {});
            } else {
                var rows = (currentMember && currentMember.pen_names) ? currentMember.pen_names : [];
                renderPenNamesEditRows(rows, currentMember || {});
            }
            togglePenButtons(false);
        }

        function endPenEdit() {
            penEditing = false;
            renderPenNames((currentMember && currentMember.pen_names) ? currentMember.pen_names : [], currentMember || {});
            togglePenButtons(false);
        }

        function savePenNames(rows) {
            if (!currentMember || !currentMember.member_code) {
                showPenTabAlert("danger", "ไม่พบ member_code สำหรับบันทึกนามปากกา");
                return;
            }
            togglePenButtons(true);
            $.ajax({
                url: API_URL,
                method: "POST",
                dataType: "json",
                data: {
                    action: "update_pen_names",
                    member_code: String(currentMember.member_code || "").trim(),
                    pen_rows_json: JSON.stringify(rows || [])
                }
            }).done(function (res) {
                if (!res || res.success !== true) {
                    showPenTabAlert("danger", (res && res.message) ? res.message : "บันทึกนามปากกาไม่สำเร็จ");
                    togglePenButtons(false);
                    return;
                }
                currentMember.pen_names = Array.isArray(rows) ? rows : [];
                endPenEdit();
                showPenTabAlert("success", (res && res.message) ? res.message : "บันทึกนามปากกาเรียบร้อยแล้ว");
                reloadAuditLogs();
            }).fail(function (xhr) {
                var msg = "บันทึกนามปากกาไม่สำเร็จ";
                if (xhr && xhr.responseJSON && xhr.responseJSON.message) msg = xhr.responseJSON.message;
                showPenTabAlert("danger", msg);
                togglePenButtons(false);
            });
        }

        function initPenInlineEditing() {
            var addBtn = document.getElementById("mct-btn-pen-add");
            var editBtn = document.getElementById("mct-btn-pen-edit");
            var cancelBtn = document.getElementById("mct-btn-pen-cancel");
            if (!addBtn || !editBtn || !cancelBtn) return;

            addBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (!penEditing) {
                    beginPenEdit(true);
                    return;
                }
                var tbody = document.getElementById("mct-pen-names-body");
                if (!tbody) return;
                var internalNo = "";
                var ipiNameNo = "";
                var ipiBaseNo = "";
                tbody.insertAdjacentHTML("beforeend",
                    "<tr>" +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-pen-internal-no font-monospace" value="' + escapeHtml(internalNo) + '" placeholder="Internal No." oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-pen-ipi-name-no font-monospace" value="' + escapeHtml(ipiNameNo) + '" placeholder="IPI Name No ของนามปากกา" oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-pen-ipi-base-no font-monospace" value="' + escapeHtml(ipiBaseNo) + '" placeholder="IPI Base No. ของนามปากกา"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-pen-name-local" placeholder="ชื่อนามปากกา (ไทย)"></td>' +
                    '<td><div class="d-flex gap-2"><input type="text" class="form-control form-control-sm mct-pen-name-eng" placeholder="ชื่อนามปากกา (English)"><button type="button" class="btn btn-sm btn-soft-danger mct-pen-row-remove">ลบ</button></div></td>' +
                    "</tr>"
                );
                bindPenRowRemoveButtons(currentMember || {});
            });

            editBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (!penEditing) {
                    beginPenEdit(false);
                    return;
                }
                var rows = collectPenRowsFromEditTable();
                savePenNames(rows);
            });

            cancelBtn.addEventListener("click", function (e) {
                e.preventDefault();
                endPenEdit();
            });

            togglePenButtons(false);
        }

        function renderBankAccounts(rows) {
            var tbody = document.getElementById("mct-bank-accounts-body");
            if (!tbody) {
                return;
            }
            if (!rows || rows.length === 0) {
                tbody.innerHTML =
                    '<tr><td colspan="6" class="text-muted small fst-italic">ยังไม่มีข้อมูล</td></tr>';
                return;
            }
            var n = 0;
            var html = rows
                .map(function (row) {
                    var bank = String(row.bank_name || "").trim();
                    var holder = String(row.account_holder_name || "").trim();
                    var num = String(row.account_number || "").trim();
                    var branch = String(row.branch_name || "").trim();
                    var typ = String(row.account_type || "").trim();
                    if (!bank && !holder && !num && !branch && !typ) {
                        return "";
                    }
                    n += 1;
                    return (
                        "<tr><td class=\"text-muted\">" +
                        n +
                        '</td><td class="text-break">' +
                        escapeHtml(bank || "—") +
                        '</td><td class="text-break">' +
                        escapeHtml(holder || "—") +
                        '</td><td class="text-break font-monospace user-select-all">' +
                        escapeHtml(num || "—") +
                        '</td><td class="text-break">' +
                        escapeHtml(branch || "—") +
                        '</td><td class="text-break">' +
                        escapeHtml(typ || "—") +
                        "</td></tr>"
                    );
                })
                .filter(Boolean);
            tbody.innerHTML =
                html.length > 0
                    ? html.join("")
                    : '<tr><td colspan="6" class="text-muted small fst-italic">ยังไม่มีข้อมูล</td></tr>';
        }

        function renderBankAccountsEditRows(rows) {
            var tbody = document.getElementById("mct-bank-accounts-body");
            if (!tbody) return;
            var list = Array.isArray(rows) ? rows.slice() : [];
            if (list.length === 0) {
                list = [{ bank_name: "", account_holder_name: "", account_number: "", branch_name: "", account_type: "" }];
            }
            var bankAccountTypeOptions = [
                { value: "", label: "" },
                { value: "ออมทรัพย์", label: "ออมทรัพย์" },
                { value: "กระแสรายวัน", label: "กระแสรายวัน" },
                { value: "ฝากประจำ", label: "ฝากประจำ" }
            ];
            var html = list.map(function (row, idx) {
                var bankName = String(row.bank_name || "");
                var accountType = String(row.account_type || "");
                var optionsHtml = '<option value=""></option>' + bankMasterOptions.map(function (opt) {
                    var val = String(opt.value || "");
                    var selected = val === bankName ? " selected" : "";
                    return '<option value="' + escapeHtml(val) + '"' + selected + ">" + escapeHtml(String(opt.label || val)) + "</option>";
                }).join("");
                if (bankName && optionsHtml.indexOf('value="' + bankName.replace(/"/g, '&quot;') + '"') === -1) {
                    optionsHtml = '<option value="' + escapeHtml(bankName) + '" selected>' + escapeHtml(bankName) + "</option>" + optionsHtml;
                }
                var accountTypeOptionsHtml = bankAccountTypeOptions.map(function (opt) {
                    var val = String(opt.value || "");
                    var selected = val === accountType ? " selected" : "";
                    return '<option value="' + escapeHtml(val) + '"' + selected + ">" + escapeHtml(String(opt.label || val)) + "</option>";
                }).join("");
                if (accountType && accountTypeOptionsHtml.indexOf('value="' + accountType.replace(/"/g, '&quot;') + '"') === -1) {
                    accountTypeOptionsHtml = '<option value="' + escapeHtml(accountType) + '" selected>' + escapeHtml(accountType) + "</option>" + accountTypeOptionsHtml;
                }
                return (
                    "<tr>" +
                    '<td class="text-muted">' + (idx + 1) + "</td>" +
                    '<td><select class="form-select form-select-sm mct-bank-select-xs mct-bank-bank-name" data-choices>' + optionsHtml + "</select></td>" +
                    '<td><input type="text" class="form-control form-control-sm mct-bank-holder-name" value="' + escapeHtml(row.account_holder_name || "") + '" placeholder="ชื่อบัญชี"></td>' +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-bank-account-number" value="' + escapeHtml(String(row.account_number || "").replace(/\D+/g, "")) + '" placeholder="เลขที่บัญชี" oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-bank-branch-name" value="' + escapeHtml(row.branch_name || "") + '" placeholder="สาขา"></td>' +
                    '<td><div class="d-flex gap-2"><select class="form-select form-select-sm mct-bank-select-xs mct-bank-account-type">' + accountTypeOptionsHtml + "</select>" +
                    '<button type="button" class="btn btn-sm btn-soft-danger mct-bank-row-remove">ลบ</button></div></td>' +
                    "</tr>"
                );
            }).join("");
            tbody.innerHTML = html;
            bindBankRowRemoveButtons();
            initChoicesWithin(tbody);
        }

        function initChoicesWithin(container) {
            if (!container || typeof window === "undefined" || typeof window.Choices !== "function") return;
            var selects = container.querySelectorAll("select[data-choices]");
            selects.forEach(function (el) {
                if (el.getAttribute("data-choices-initialized") === "1") return;
                try {
                    new window.Choices(el, {
                        shouldSort: false,
                        searchEnabled: true,
                        itemSelectText: ""
                    });
                    el.setAttribute("data-choices-initialized", "1");
                } catch (e) {
                    // ignore choices init errors; native select still works
                }
            });
        }

        function bindBankRowRemoveButtons() {
            var tbody = document.getElementById("mct-bank-accounts-body");
            if (!tbody) return;
            var removeButtons = tbody.querySelectorAll(".mct-bank-row-remove");
            removeButtons.forEach(function (btn) {
                btn.onclick = function () {
                    var tr = btn.closest("tr");
                    if (tr) tr.remove();
                    if (!tbody.querySelector("tr")) {
                        renderBankAccountsEditRows([]);
                    } else {
                        var rows = tbody.querySelectorAll("tr");
                        rows.forEach(function (row, idx) {
                            var nCell = row.querySelector("td");
                            if (nCell) nCell.textContent = String(idx + 1);
                        });
                    }
                };
            });
        }

        function collectBankRowsFromEditTable() {
            var tbody = document.getElementById("mct-bank-accounts-body");
            if (!tbody) return [];
            var rows = [];
            var trList = tbody.querySelectorAll("tr");
            trList.forEach(function (tr) {
                var bank = String((tr.querySelector(".mct-bank-bank-name") || {}).value || "").trim();
                var holder = String((tr.querySelector(".mct-bank-holder-name") || {}).value || "").trim();
                var num = String((tr.querySelector(".mct-bank-account-number") || {}).value || "").replace(/\D+/g, "").trim();
                var branch = String((tr.querySelector(".mct-bank-branch-name") || {}).value || "").trim();
                var typ = String((tr.querySelector(".mct-bank-account-type") || {}).value || "").trim();
                if (!bank && !holder && !num && !branch && !typ) return;
                rows.push({
                    bank_name: bank,
                    account_holder_name: holder,
                    account_number: num,
                    branch_name: branch,
                    account_type: typ
                });
            });
            return rows;
        }

        function toggleBankButtons(loading) {
            var editBtn = document.getElementById("mct-btn-bank-edit");
            var addBtn = document.getElementById("mct-btn-bank-add");
            var cancelBtn = document.getElementById("mct-btn-bank-cancel");
            if (!editBtn || !addBtn || !cancelBtn) return;
            if (bankEditing) {
                editBtn.innerHTML = loading
                    ? '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>กำลังบันทึก...'
                    : '<i class="ri-save-line align-bottom me-1"></i>บันทึกข้อมูล';
                addBtn.innerHTML = '<i class="ri-add-line align-bottom me-1"></i>เพิ่มบัญชีธนาคาร';
                addBtn.classList.remove("d-none");
                cancelBtn.classList.remove("d-none");
            } else {
                editBtn.innerHTML = '<i class="ri-edit-2-line align-bottom me-1"></i>แก้ไขบัญชีธนาคาร';
                addBtn.innerHTML = '<i class="ri-add-line align-bottom me-1"></i>เพิ่มบัญชีธนาคาร';
                addBtn.classList.add("d-none");
                cancelBtn.classList.add("d-none");
            }
        }

        function beginBankEdit(addBlankRow) {
            bankEditing = true;
            if (addBlankRow) {
                // Add flow: start with only one editable row.
                renderBankAccountsEditRows([]);
            } else {
                var rows = (currentMember && currentMember.bank_accounts) ? currentMember.bank_accounts : [];
                renderBankAccountsEditRows(rows);
            }
            toggleBankButtons(false);
        }

        function endBankEdit() {
            bankEditing = false;
            renderBankAccounts((currentMember && currentMember.bank_accounts) ? currentMember.bank_accounts : []);
            toggleBankButtons(false);
        }

        function saveBankAccounts(rows) {
            if (!currentMember || !currentMember.member_code) {
                showBankTabAlert("danger", "ไม่พบ member_code สำหรับบันทึกบัญชีธนาคาร");
                return;
            }
            toggleBankButtons(true);
            $.ajax({
                url: API_URL,
                method: "POST",
                dataType: "json",
                data: {
                    action: "update_bank_accounts",
                    member_code: String(currentMember.member_code || "").trim(),
                    bank_rows_json: JSON.stringify(rows || [])
                }
            }).done(function (res) {
                if (!res || res.success !== true) {
                    showBankTabAlert("danger", (res && res.message) ? res.message : "บันทึกบัญชีธนาคารไม่สำเร็จ");
                    toggleBankButtons(false);
                    return;
                }
                currentMember.bank_accounts = Array.isArray(rows) ? rows : [];
                endBankEdit();
                showBankTabAlert("success", (res && res.message) ? res.message : "บันทึกบัญชีธนาคารเรียบร้อยแล้ว");
                reloadAuditLogs();
            }).fail(function (xhr) {
                var msg = "บันทึกบัญชีธนาคารไม่สำเร็จ";
                if (xhr && xhr.responseJSON && xhr.responseJSON.message) msg = xhr.responseJSON.message;
                showBankTabAlert("danger", msg);
                toggleBankButtons(false);
            });
        }

        function initBankInlineEditing() {
            var addBtn = document.getElementById("mct-btn-bank-add");
            var editBtn = document.getElementById("mct-btn-bank-edit");
            var cancelBtn = document.getElementById("mct-btn-bank-cancel");
            if (!addBtn || !editBtn || !cancelBtn) return;

            addBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (!bankEditing) {
                    beginBankEdit(true);
                    return;
                }
                var tbody = document.getElementById("mct-bank-accounts-body");
                if (!tbody) return;
                tbody.insertAdjacentHTML("beforeend",
                    "<tr>" +
                    '<td class="text-muted"></td>' +
                    '<td><select class="form-select form-select-sm mct-bank-select-xs mct-bank-bank-name" data-choices><option value=""></option>' + bankMasterOptions.map(function (opt) {
                        var val = String(opt.value || "");
                        return '<option value="' + escapeHtml(val) + '">' + escapeHtml(String(opt.label || val)) + "</option>";
                    }).join("") + "</select></td>" +
                    '<td><input type="text" class="form-control form-control-sm mct-bank-holder-name" placeholder="ชื่อบัญชี"></td>' +
                    '<td><input type="text" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm mct-bank-account-number" placeholder="เลขที่บัญชี" oninput="this.value=this.value.replace(/\\D+/g,\'\')"></td>' +
                    '<td><input type="text" class="form-control form-control-sm mct-bank-branch-name" placeholder="สาขา"></td>' +
                    '<td><div class="d-flex gap-2"><select class="form-select form-select-sm mct-bank-select-xs mct-bank-account-type"><option value=""></option><option value="ออมทรัพย์">ออมทรัพย์</option><option value="กระแสรายวัน">กระแสรายวัน</option><option value="ฝากประจำ">ฝากประจำ</option></select><button type="button" class="btn btn-sm btn-soft-danger mct-bank-row-remove">ลบ</button></div></td>' +
                    "</tr>"
                );
                bindBankRowRemoveButtons();
                initChoicesWithin(tbody);
                var rows = tbody.querySelectorAll("tr");
                rows.forEach(function (row, idx) {
                    var nCell = row.querySelector("td");
                    if (nCell) nCell.textContent = String(idx + 1);
                });
            });

            editBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (!bankEditing) {
                    beginBankEdit(false);
                    return;
                }
                var rows = collectBankRowsFromEditTable();
                saveBankAccounts(rows);
            });

            cancelBtn.addEventListener("click", function (e) {
                e.preventDefault();
                endBankEdit();
            });
        }

        function loadBankMasterOptions() {
            return fetch(API_URL + "?action=bank_master_options", {
                method: "GET",
                headers: { "X-Requested-With": "XMLHttpRequest" }
            })
                .then(function (res) {
                    return res.text().then(function (text) {
                        var data = {};
                        try {
                            data = text ? JSON.parse(text) : {};
                        } catch (e) {
                            data = {};
                        }
                        if (!res.ok || !data || data.success !== true) {
                            return [];
                        }
                        return Array.isArray(data.options) ? data.options : [];
                    });
                })
                .then(function (opts) {
                    bankMasterOptions = opts;
                })
                .catch(function () {
                    bankMasterOptions = [];
                });
        }

        function formatFileSize(bytes) {
            var b = Number(bytes || 0);
            if (b <= 0) return "0 B";
            var units = ["B", "KB", "MB", "GB", "TB"];
            var i = 0;
            while (b >= 1024 && i < units.length - 1) {
                b = b / 1024;
                i++;
            }
            var fixed = b >= 100 || i === 0 ? 0 : 1;
            return b.toFixed(fixed) + " " + units[i];
        }

        function renderDocUsage(usage) {
            var used = Number((usage && usage.used_bytes) || 0);
            var quota = Number((usage && usage.quota_bytes) || 1073741824);
            if (!isFinite(used) || used < 0) used = 0;
            if (!isFinite(quota) || quota <= 0) quota = 1073741824;
            var pct = Math.max(0, Math.min(100, (used / quota) * 100));
            if (els.docsUsageText) {
                els.docsUsageText.textContent = formatFileSize(used) + " / " + formatFileSize(quota);
            }
            if (els.docsUsageBar) {
                els.docsUsageBar.style.width = pct.toFixed(1) + "%";
                els.docsUsageBar.setAttribute("aria-valuenow", String(Math.round(pct)));
                els.docsUsageBar.classList.remove("bg-success", "bg-warning", "bg-danger");
                if (pct >= 90) {
                    els.docsUsageBar.classList.add("bg-danger");
                } else if (pct >= 70) {
                    els.docsUsageBar.classList.add("bg-warning");
                } else {
                    els.docsUsageBar.classList.add("bg-success");
                }
            }
        }

        function parentDocFolderPath(path) {
            var p = String(path || "").trim();
            var idx = p.lastIndexOf("/");
            return idx === -1 ? "" : p.slice(0, idx);
        }

        function folderExists(path) {
            var p = String(path || "").trim();
            if (p === "") return true;
            return ((currentMember && currentMember.doc_folders) || []).some(function (f) {
                return String((f && f.folder_path) || "").trim() === p;
            });
        }

        function countFilesInFolder(path) {
            var p = String(path || "").trim();
            return ((currentMember && currentMember.doc_files) || []).filter(function (row) {
                return String((row && row.folder_path) || "").trim() === p;
            }).length;
        }

        function getChildFolders(path) {
            var prefix = path ? path + "/" : "";
            return ((currentMember && currentMember.doc_folders) || []).filter(function (f) {
                var p = String((f && f.folder_path) || "").trim();
                if (!p) return false;
                if (!path) return p.indexOf("/") === -1;
                if (p.indexOf(prefix) !== 0) return false;
                return p.slice(prefix.length).indexOf("/") === -1;
            }).sort(function (a, b) {
                return String(a.folder_path || "").localeCompare(String(b.folder_path || ""), "th");
            });
        }

        function formatDocDate(raw) {
            var s = String(raw || "").trim();
            if (!s) return "—";
            var m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
            if (!m) return s;
            var months = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
            var year = Number(m[1]) + 543;
            var month = months[Number(m[2]) - 1] || m[2];
            var day = String(Number(m[3]));
            var time = m[4] ? (" " + m[4] + ":" + m[5] + " น.") : "";
            return day + " " + month + " " + year + time;
        }

        function getDocFileMeta(fileName, mimeType) {
            var ext = String(fileName || "").split(".").pop().toLowerCase();
            var mime = String(mimeType || "").toLowerCase();
            if (mime.indexOf("image/") === 0) {
                ext = "image";
            }
            var map = {
                pdf: { icon: "ri-file-pdf-2-fill", cls: "bg-danger-subtle text-danger", label: "PDF", image: false },
                doc: { icon: "ri-file-word-2-fill", cls: "bg-primary-subtle text-primary", label: "Word", image: false },
                docx: { icon: "ri-file-word-2-fill", cls: "bg-primary-subtle text-primary", label: "Word", image: false },
                xls: { icon: "ri-file-excel-2-fill", cls: "bg-success-subtle text-success", label: "Excel", image: false },
                xlsx: { icon: "ri-file-excel-2-fill", cls: "bg-success-subtle text-success", label: "Excel", image: false },
                txt: { icon: "ri-file-text-fill", cls: "bg-secondary-subtle text-secondary", label: "ข้อความ", image: false },
                jpg: { icon: "ri-image-2-fill", cls: "bg-info-subtle text-info", label: "รูปภาพ", image: true },
                jpeg: { icon: "ri-image-2-fill", cls: "bg-info-subtle text-info", label: "รูปภาพ", image: true },
                png: { icon: "ri-image-2-fill", cls: "bg-info-subtle text-info", label: "รูปภาพ", image: true },
                image: { icon: "ri-image-2-fill", cls: "bg-info-subtle text-info", label: "รูปภาพ", image: true }
            };
            return map[ext] || { icon: "ri-file-3-fill", cls: "bg-light text-muted", label: (ext || "ไฟล์").toUpperCase(), image: false };
        }

        function setDocsUploading(on, total, current) {
            docsUploading = !!on;
            if (els.docsDropzone) {
                els.docsDropzone.classList.toggle("is-uploading", docsUploading);
            }
            if (els.docsDropzoneStatus) {
                if (docsUploading) {
                    var n = Number(current || 0);
                    var t = Number(total || 0);
                    els.docsDropzoneStatus.textContent = t > 1
                        ? "กำลังอัปโหลดไฟล์ " + n + " / " + t + " ..."
                        : "กำลังอัปโหลดไฟล์...";
                } else {
                    els.docsDropzoneStatus.textContent = "ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์";
                }
            }
        }

        function openDocFolder(path) {
            currentDocFolderPath = String(path || "").trim();
            if (!folderExists(currentDocFolderPath)) {
                currentDocFolderPath = "";
            }
            if (currentMember) {
                renderDocumentManager(currentMember);
            }
        }

        function renderDocBreadcrumb() {
            if (!els.docsBreadcrumb) return;
            var parts = currentDocFolderPath ? currentDocFolderPath.split("/") : [];
            var html = '<button type="button" class="mct-docs-crumb' + (parts.length ? "" : " is-current") + '" data-folder-path="">โฟลเดอร์หลัก</button>';
            var acc = "";
            parts.forEach(function (part, idx) {
                acc = acc ? acc + "/" + part : part;
                html += '<span class="text-muted mx-1">/</span>';
                html += '<button type="button" class="mct-docs-crumb' + (idx === parts.length - 1 ? " is-current" : "") + '" data-folder-path="' + escapeHtml(acc) + '">' + escapeHtml(part) + "</button>";
            });
            els.docsBreadcrumb.innerHTML = html;
        }

        function renderDocFolderTree() {
            if (!els.docsFolderTree) return;
            var folders = ((currentMember && currentMember.doc_folders) || [])
                .map(function (f) { return String((f && f.folder_path) || "").trim(); })
                .filter(Boolean)
                .sort(function (a, b) { return a.localeCompare(b, "th"); });
            var items = ['<button type="button" class="mct-docs-tree-item' + (currentDocFolderPath === "" ? " is-active" : "") + '" data-folder-path="" style="padding-left:0.55rem">' +
                '<i class="ri-folder' + (currentDocFolderPath === "" ? "-open" : "") + '-fill text-warning"></i>' +
                '<span class="text-truncate flex-grow-1">โฟลเดอร์หลัก</span>' +
                '<span class="badge bg-white text-muted border fw-normal">' + countFilesInFolder("") + "</span></button>"];
            folders.forEach(function (p) {
                var depth = p.split("/").length;
                var name = p.split("/").pop();
                var active = currentDocFolderPath === p;
                items.push(
                    '<button type="button" class="mct-docs-tree-item' + (active ? " is-active" : "") + '" data-folder-path="' + escapeHtml(p) + '" style="padding-left:' + (0.55 + depth * 0.7) + 'rem">' +
                    '<i class="ri-folder' + (active ? "-open" : "") + '-fill text-warning"></i>' +
                    '<span class="text-truncate flex-grow-1">' + escapeHtml(name) + "</span>" +
                    '<span class="badge bg-white text-muted border fw-normal">' + countFilesInFolder(p) + "</span></button>"
                );
            });
            els.docsFolderTree.innerHTML = items.join("");
        }

        function docsEmptyState(title, hint) {
            return (
                '<div class="mct-docs-empty text-center py-5 px-3">' +
                '<span class="avatar-md rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center mb-3" style="width:3.25rem;height:3.25rem;">' +
                '<i class="ri-folder-open-line fs-22"></i></span>' +
                '<h6 class="mb-1">' + escapeHtml(title) + "</h6>" +
                '<p class="text-muted small mb-0">' + escapeHtml(hint) + "</p></div>"
            );
        }

        function renderDocumentManager(member) {
            currentMember.doc_folders = Array.isArray(member.doc_folders) ? member.doc_folders : [];
            currentMember.doc_files = Array.isArray(member.doc_files) ? member.doc_files : [];
            currentMember.docs_usage = member.docs_usage || { used_bytes: 0, quota_bytes: 1073741824 };
            if (!folderExists(currentDocFolderPath)) {
                currentDocFolderPath = "";
            }
            renderDocUsage(currentMember.docs_usage);
            renderDocFolderTree();
            renderDocBreadcrumb();

            var allFiles = currentMember.doc_files || [];
            if (els.docsCountBadge) {
                els.docsCountBadge.textContent = allFiles.length + " ไฟล์";
            }
            if (els.docsDeleteBtn) {
                els.docsDeleteBtn.disabled = currentDocFolderPath === "";
            }

            if (!els.docsFilesBody) return;
            var q = currentDocSearchQuery;
            var files;
            var childFolders = [];
            if (q) {
                files = allFiles.filter(function (row) {
                    var label = String(row.doc_label || "").toLowerCase();
                    var name = String(row.file_name || "").toLowerCase();
                    var folder = String(row.folder_path || "").toLowerCase();
                    return label.indexOf(q) !== -1 || name.indexOf(q) !== -1 || folder.indexOf(q) !== -1;
                });
            } else {
                childFolders = getChildFolders(currentDocFolderPath);
                files = allFiles.filter(function (row) {
                    return String(row.folder_path || "").trim() === currentDocFolderPath;
                });
            }

            var html = "";
            if (!q && childFolders.length) {
                html += '<div class="mct-docs-subfolders mb-3">';
                childFolders.forEach(function (f) {
                    var p = String(f.folder_path || "").trim();
                    var name = String(f.folder_name || p.split("/").pop() || "").trim();
                    html +=
                        '<button type="button" class="mct-docs-folder-card" data-folder-path="' + escapeHtml(p) + '">' +
                        '<i class="ri-folder-fill text-warning"></i>' +
                        '<span class="text-truncate">' + escapeHtml(name) + "</span>" +
                        '<span class="small text-muted">' + countFilesInFolder(p) + " ไฟล์</span></button>";
                });
                html += "</div>";
            }

            if (!files.length) {
                if (q) {
                    html += docsEmptyState("ไม่พบเอกสารที่ตรงกับคำค้น", "ลองเปลี่ยนคำค้นหา หรือล้างช่องค้นหาเพื่อดูไฟล์ในโฟลเดอร์นี้");
                } else if (!childFolders.length && !allFiles.length) {
                    html += docsEmptyState("ยังไม่มีเอกสาร", "ลากไฟล์มาวางด้านบน หรือคลิกกล่องอัปโหลดเพื่อเลือกไฟล์จากเครื่อง");
                } else if (!childFolders.length) {
                    html += docsEmptyState("โฟลเดอร์นี้ยังไม่มีไฟล์", "อัปโหลดเอกสารเข้าโฟลเดอร์นี้ หรือสร้างโฟลเดอร์ย่อย");
                }
                els.docsFilesBody.innerHTML = html;
                return;
            }

            html += files.map(function (row) {
                var id = Number(row.id || 0);
                var folder = String(row.folder_path || "").trim();
                var label = String(row.doc_label || "").trim();
                var fileName = String(row.file_name || "").trim();
                var href = publicHref(String(row.storage_path || "").trim());
                var meta = getDocFileMeta(fileName, row.mime_type);
                var title = label || fileName || "เอกสาร";
                var thumb = meta.image && href
                    ? '<img class="mct-docs-thumb" src="' + escapeHtml(href) + '" alt="">'
                    : '<span class="mct-docs-file-icon ' + meta.cls + '"><i class="' + meta.icon + '"></i></span>';
                var titleHtml = href
                    ? '<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener" class="fw-semibold text-break link-dark text-decoration-none">' + escapeHtml(title) + "</a>"
                    : '<div class="fw-semibold text-break">' + escapeHtml(title) + "</div>";
                return (
                    '<div class="mct-docs-file-row">' +
                    thumb +
                    '<div class="min-w-0 flex-grow-1">' +
                    titleHtml +
                    '<div class="small text-muted text-break">' +
                    escapeHtml(meta.label) +
                    (fileName && fileName !== title ? " · " + escapeHtml(fileName) : "") +
                    " · " + escapeHtml(formatFileSize(row.file_size_bytes || 0)) +
                    " · " + escapeHtml(formatDocDate(row.created_at)) +
                    (q && folder ? ' · <span class="badge bg-light text-muted border fw-normal">' + escapeHtml(folder) + "</span>" : "") +
                    "</div></div>" +
                    '<div class="d-inline-flex gap-1 flex-shrink-0">' +
                    (href ? ('<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener" class="btn btn-sm btn-soft-primary" title="เปิด / ดาวน์โหลด"><i class="ri-download-2-line"></i></a>') : "") +
                    '<button type="button" class="btn btn-sm btn-soft-danger mct-doc-file-delete" data-doc-id="' + escapeHtml(String(id)) + '" title="ลบไฟล์"><i class="ri-delete-bin-5-line"></i></button>' +
                    "</div></div>"
                );
            }).join("");
            els.docsFilesBody.innerHTML = html;
        }

        function applyUploadedFile(data) {
            if (data && data.file) {
                currentMember.doc_files = [data.file].concat(currentMember.doc_files || []);
            }
            if (data && data.usage) {
                currentMember.docs_usage = data.usage;
            }
            var folderPath = String((data && data.file && data.file.folder_path) || "").trim();
            if (folderPath) {
                var exists = (currentMember.doc_folders || []).some(function (f) {
                    return String((f && f.folder_path) || "").trim() === folderPath;
                });
                if (!exists) {
                    currentMember.doc_folders = (currentMember.doc_folders || []).concat([{
                        folder_path: folderPath,
                        folder_name: folderPath.split("/").pop()
                    }]);
                }
            }
        }

        function uploadDocFile(file) {
            var formData = new FormData();
            formData.append("action", "docs_upload_file");
            formData.append("member_code", String(currentMember.member_code || "").trim());
            formData.append("folder_path", currentDocFolderPath);
            formData.append("doc_label", String((els.docsUploadLabel && els.docsUploadLabel.value) || "").trim());
            formData.append("doc_file", file);
            return fetch(API_URL, {
                method: "POST",
                headers: { "X-Requested-With": "XMLHttpRequest" },
                body: formData
            }).then(function (res) {
                return res.text().then(function (text) {
                    var data = {};
                    try {
                        data = text ? JSON.parse(text) : {};
                    } catch (e) {
                        throw new Error("API ไม่ได้ส่ง JSON ที่ถูกต้อง");
                    }
                    if (!res.ok || !data || data.success !== true) {
                        throw new Error((data && data.message) ? data.message : "อัปโหลดไฟล์เอกสารไม่สำเร็จ");
                    }
                    return data;
                });
            });
        }

        function uploadDocFiles(fileList) {
            var list = Array.prototype.slice.call(fileList || []).filter(Boolean);
            if (!list.length) {
                showDocsTabAlert("danger", "กรุณาเลือกไฟล์เอกสาร");
                return;
            }
            if (!currentMember || !currentMember.member_code) {
                showDocsTabAlert("danger", "ไม่พบ member_code");
                return;
            }
            if (docsUploading) return;
            var i = 0;
            setDocsUploading(true, list.length, 1);
            function next() {
                if (i >= list.length) {
                    setDocsUploading(false);
                    if (els.docsUploadLabel) els.docsUploadLabel.value = "";
                    if (els.docsUploadFile) els.docsUploadFile.value = "";
                    renderDocumentManager(currentMember);
                    showDocsTabAlert("success", list.length > 1 ? "อัปโหลดไฟล์เอกสาร " + list.length + " ไฟล์เรียบร้อยแล้ว" : "อัปโหลดไฟล์เอกสารเรียบร้อยแล้ว");
                    reloadAuditLogs();
                    return;
                }
                setDocsUploading(true, list.length, i + 1);
                uploadDocFile(list[i]).then(function (data) {
                    applyUploadedFile(data);
                    i += 1;
                    next();
                }).catch(function (err) {
                    setDocsUploading(false);
                    renderDocumentManager(currentMember);
                    showDocsTabAlert("danger", err && err.message ? err.message : "อัปโหลดไฟล์เอกสารไม่สำเร็จ");
                    if (els.docsUploadFile) els.docsUploadFile.value = "";
                });
            }
            next();
        }

        function initDocumentManager() {
            if (els.docsToggleFolderForm && els.docsFolderForm) {
                els.docsToggleFolderForm.addEventListener("click", function () {
                    els.docsFolderForm.classList.toggle("d-none");
                    if (!els.docsFolderForm.classList.contains("d-none") && els.docsNewFolderName) {
                        els.docsNewFolderName.focus();
                    }
                });
            }

            if (els.docsNewFolderName) {
                els.docsNewFolderName.addEventListener("keydown", function (e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        if (els.docsCreateBtn) els.docsCreateBtn.click();
                    }
                });
            }

            if (els.docsCreateBtn) {
                els.docsCreateBtn.addEventListener("click", function () {
                    if (!currentMember || !currentMember.member_code) {
                        showDocsTabAlert("danger", "ไม่พบ member_code");
                        return;
                    }
                    var folderName = String((els.docsNewFolderName && els.docsNewFolderName.value) || "").trim();
                    if (!folderName) {
                        showDocsTabAlert("danger", "กรุณาระบุชื่อโฟลเดอร์");
                        return;
                    }
                    $.ajax({
                        url: API_URL,
                        method: "POST",
                        dataType: "json",
                        data: {
                            action: "docs_create_folder",
                            member_code: String(currentMember.member_code || "").trim(),
                            folder_name: folderName,
                            parent_folder_path: currentDocFolderPath
                        }
                    }).done(function (res) {
                        if (!res || res.success !== true) {
                            showDocsTabAlert("danger", (res && res.message) ? res.message : "สร้างโฟลเดอร์ไม่สำเร็จ");
                            return;
                        }
                        var newFolderPath = String((res && res.folder_path) || "").trim();
                        if (newFolderPath) {
                            var exists = (currentMember.doc_folders || []).some(function (f) {
                                return String((f && f.folder_path) || "").trim() === newFolderPath;
                            });
                            if (!exists) {
                                currentMember.doc_folders = (currentMember.doc_folders || []).concat([{
                                    folder_path: newFolderPath,
                                    folder_name: String((res && res.folder_name) || "").trim()
                                }]);
                            }
                        }
                        if (els.docsNewFolderName) {
                            els.docsNewFolderName.value = "";
                        }
                        if (els.docsFolderForm) {
                            els.docsFolderForm.classList.add("d-none");
                        }
                        renderDocumentManager(currentMember);
                        showDocsTabAlert("success", (res && res.message) ? res.message : "สร้างโฟลเดอร์เรียบร้อยแล้ว");
                        reloadAuditLogs();
                    }).fail(function (xhr) {
                        var msg = "สร้างโฟลเดอร์ไม่สำเร็จ";
                        if (xhr && xhr.responseJSON && xhr.responseJSON.message) msg = xhr.responseJSON.message;
                        showDocsTabAlert("danger", msg);
                    });
                });
            }

            if (els.docsDeleteBtn) {
                els.docsDeleteBtn.addEventListener("click", function () {
                    if (!currentMember || !currentMember.member_code) {
                        showDocsTabAlert("danger", "ไม่พบ member_code");
                        return;
                    }
                    var folderPath = currentDocFolderPath;
                    if (!folderPath) {
                        showDocsTabAlert("danger", "กรุณาเลือกโฟลเดอร์ที่ต้องการลบ");
                        return;
                    }
                    if (!window.confirm('ยืนยันลบโฟลเดอร์ "' + folderPath + '" และไฟล์ภายในทั้งหมด?')) {
                        return;
                    }
                    $.ajax({
                        url: API_URL,
                        method: "POST",
                        dataType: "json",
                        data: {
                            action: "docs_delete_folder",
                            member_code: String(currentMember.member_code || "").trim(),
                            folder_path: folderPath
                        }
                    }).done(function (res) {
                        if (!res || res.success !== true) {
                            showDocsTabAlert("danger", (res && res.message) ? res.message : "ลบโฟลเดอร์ไม่สำเร็จ");
                            return;
                        }
                        var deletedPath = String((res && res.deleted_folder_path) || folderPath).trim();
                        currentMember.doc_folders = (currentMember.doc_folders || []).filter(function (f) {
                            var p = String((f && f.folder_path) || "").trim();
                            return !(p === deletedPath || p.indexOf(deletedPath + "/") === 0);
                        });
                        currentMember.doc_files = (currentMember.doc_files || []).filter(function (f) {
                            var p = String((f && f.folder_path) || "").trim();
                            return !(p === deletedPath || p.indexOf(deletedPath + "/") === 0);
                        });
                        if (res && res.usage) {
                            currentMember.docs_usage = res.usage;
                        }
                        currentDocFolderPath = parentDocFolderPath(deletedPath);
                        renderDocumentManager(currentMember);
                        showDocsTabAlert("success", (res && res.message) ? res.message : "ลบโฟลเดอร์เรียบร้อยแล้ว");
                        reloadAuditLogs();
                    }).fail(function (xhr) {
                        var msg = "ลบโฟลเดอร์ไม่สำเร็จ";
                        if (xhr && xhr.responseJSON && xhr.responseJSON.message) msg = xhr.responseJSON.message;
                        showDocsTabAlert("danger", msg);
                    });
                });
            }

            if (els.docsSearch) {
                els.docsSearch.addEventListener("input", function () {
                    currentDocSearchQuery = String(els.docsSearch.value || "").trim().toLowerCase();
                    if (currentMember) {
                        renderDocumentManager(currentMember);
                    }
                });
            }

            if (els.docsFolderTree) {
                els.docsFolderTree.addEventListener("click", function (e) {
                    var btn = e.target.closest("[data-folder-path]");
                    if (!btn) return;
                    openDocFolder(btn.getAttribute("data-folder-path") || "");
                });
            }

            if (els.docsBreadcrumb) {
                els.docsBreadcrumb.addEventListener("click", function (e) {
                    var btn = e.target.closest("[data-folder-path]");
                    if (!btn) return;
                    openDocFolder(btn.getAttribute("data-folder-path") || "");
                });
            }

            if (els.docsFilesBody) {
                els.docsFilesBody.addEventListener("click", function (e) {
                    var folderBtn = e.target.closest(".mct-docs-folder-card");
                    if (folderBtn) {
                        openDocFolder(folderBtn.getAttribute("data-folder-path") || "");
                        return;
                    }
                    var delBtn = e.target.closest(".mct-doc-file-delete");
                    if (!delBtn) return;
                    var docId = Number(delBtn.getAttribute("data-doc-id") || "0");
                    if (!docId || !currentMember || !currentMember.member_code) return;
                    if (!window.confirm("ยืนยันการลบไฟล์เอกสารนี้?")) return;
                    $.ajax({
                        url: API_URL,
                        method: "POST",
                        dataType: "json",
                        data: {
                            action: "docs_delete_file",
                            member_code: String(currentMember.member_code || "").trim(),
                            doc_id: String(docId)
                        }
                    }).done(function (res) {
                        if (!res || res.success !== true) {
                            showDocsTabAlert("danger", (res && res.message) ? res.message : "ลบไฟล์ไม่สำเร็จ");
                            return;
                        }
                        currentMember.doc_files = (currentMember.doc_files || []).filter(function (f) {
                            return Number((f && f.id) || 0) !== docId;
                        });
                        if (res.usage) {
                            currentMember.docs_usage = res.usage;
                        }
                        renderDocumentManager(currentMember);
                        showDocsTabAlert("success", (res && res.message) ? res.message : "ลบไฟล์เอกสารเรียบร้อยแล้ว");
                        reloadAuditLogs();
                    }).fail(function (xhr) {
                        var msg = "ลบไฟล์เอกสารไม่สำเร็จ";
                        if (xhr && xhr.responseJSON && xhr.responseJSON.message) msg = xhr.responseJSON.message;
                        showDocsTabAlert("danger", msg);
                    });
                });
            }

            function openFilePicker() {
                if (docsUploading) return;
                if (els.docsUploadFile) els.docsUploadFile.click();
            }

            if (els.docsDropzone) {
                els.docsDropzone.addEventListener("click", function () {
                    openFilePicker();
                });
                els.docsDropzone.addEventListener("keydown", function (e) {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openFilePicker();
                    }
                });
                els.docsDropzone.addEventListener("dragover", function (e) {
                    e.preventDefault();
                    els.docsDropzone.classList.add("is-dragover");
                });
                els.docsDropzone.addEventListener("dragleave", function () {
                    els.docsDropzone.classList.remove("is-dragover");
                });
                els.docsDropzone.addEventListener("drop", function (e) {
                    e.preventDefault();
                    els.docsDropzone.classList.remove("is-dragover");
                    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
                        uploadDocFiles(e.dataTransfer.files);
                    }
                });
            }

            if (els.docsUploadFile) {
                els.docsUploadFile.addEventListener("change", function () {
                    uploadDocFiles(els.docsUploadFile.files);
                });
            }

            if (els.docsUploadBtn) {
                els.docsUploadBtn.addEventListener("click", function () {
                    uploadDocFiles(els.docsUploadFile && els.docsUploadFile.files);
                });
            }
        }

        function renderSongRoleColumn(people) {
            people = Array.isArray(people) ? people : [];
            if (!people.length) {
                return '<span class="text-muted">—</span>';
            }
            return people
                .map(function (person) {
                    var name = String(person && person.display_name ? person.display_name : "").trim() || "—";
                    var isSelf = !!(person && person.is_self);
                    var badge = isSelf
                        ? ""
                        : ' <span class="mct-profile-song-collab-badge">ผู้แต่งร่วม</span>';
                    return (
                        '<div class="mct-profile-song-role-person' +
                        (isSelf ? " is-self" : " is-collab") +
                        '">' +
                        escapeHtml(name) +
                        badge +
                        "</div>"
                    );
                })
                .join("");
        }

        function songWorksSearchText(row) {
            var parts = [
                row && row.work_id,
                row && row.title_local,
                row && row.title_eng,
                row && row.artist_name,
                row && row.iswc,
                row && row.note
            ];
            if (row && Array.isArray(row.role_labels)) {
                parts = parts.concat(row.role_labels);
            }
            if (row && Array.isArray(row.roles)) {
                parts = parts.concat(row.roles);
            }
            if (row && row.collaborators && typeof row.collaborators === "object") {
                ["melody", "lyrics", "arrangement", "publisher"].forEach(function (group) {
                    (Array.isArray(row.collaborators[group]) ? row.collaborators[group] : []).forEach(function (person) {
                        parts.push(person && person.display_name);
                        parts.push(person && person.member_code);
                        if (!(person && person.is_self)) {
                            parts.push("ผู้แต่งร่วม");
                        }
                    });
                });
            }
            return parts
                .map(function (v) {
                    return String(v || "").toLowerCase();
                })
                .join(" ");
        }

        function filterSongWorks(rows, query) {
            var q = String(query || "").trim().toLowerCase();
            var list = Array.isArray(rows) ? rows : [];
            if (q === "") {
                return list;
            }
            return list.filter(function (row) {
                return songWorksSearchText(row).indexOf(q) !== -1;
            });
        }

        function songWorksPageNumbers(page, totalPages) {
            var start = Math.max(1, page - 2);
            var end = Math.min(totalPages, start + 4);
            start = Math.max(1, end - 4);
            var nums = [];
            var i;
            for (i = start; i <= end; i++) {
                nums.push(i);
            }
            return nums;
        }

        function renderSongWorksPager(filteredCount, from, to, page, totalPages) {
            var pager = document.getElementById("mct-song-works-pager");
            var info = document.getElementById("mct-song-works-page-info");
            var list = document.getElementById("mct-song-works-page-list");
            var prev = document.getElementById("mct-song-works-prev");
            var next = document.getElementById("mct-song-works-next");
            var hasRows = filteredCount > 0;
            if (pager) {
                pager.classList.toggle("d-none", songWorksState.all.length === 0);
            }
            if (info) {
                info.textContent = hasRows
                    ? "แสดง " + from + "-" + to + " จาก " + filteredCount + " รายการ"
                    : songWorksState.query
                      ? "ไม่พบเพลงที่ตรงกับคำค้น"
                      : "ยังไม่มีข้อมูลเพลงของสมาชิกนี้";
            }
            if (prev) {
                prev.disabled = page <= 1 || !hasRows;
            }
            if (next) {
                next.disabled = page >= totalPages || !hasRows;
            }
            if (!list) {
                return;
            }
            if (!hasRows || totalPages <= 1) {
                list.innerHTML = "";
                return;
            }
            list.innerHTML = songWorksPageNumbers(page, totalPages)
                .map(function (n) {
                    return (
                        '<li class="page-item' +
                        (n === page ? " active" : "") +
                        '"><button type="button" class="page-link" data-song-page="' +
                        n +
                        '">' +
                        n +
                        "</button></li>"
                    );
                })
                .join("");
        }

        function renderSongWorksPage() {
            var tbody = document.getElementById("mct-song-works-body");
            var countEl = document.getElementById("mct-song-works-count");
            var filtered = filterSongWorks(songWorksState.all, songWorksState.query);
            var perPage = songWorksState.perPage === 25 || songWorksState.perPage === 50 ? songWorksState.perPage : 10;
            songWorksState.perPage = perPage;
            var total = filtered.length;
            var totalPages = Math.max(1, Math.ceil(total / perPage));
            if (songWorksState.page > totalPages) {
                songWorksState.page = totalPages;
            }
            if (songWorksState.page < 1) {
                songWorksState.page = 1;
            }
            var page = songWorksState.page;
            var start = (page - 1) * perPage;
            var pageRows = filtered.slice(start, start + perPage);
            var from = total === 0 ? 0 : start + 1;
            var to = start + pageRows.length;
            if (countEl) {
                countEl.textContent = songWorksState.all.length ? "(" + songWorksState.all.length + ")" : "";
            }
            renderSongWorksPager(total, from, to, page, totalPages);
            if (!tbody) {
                return;
            }
            if (songWorksState.all.length === 0) {
                tbody.innerHTML =
                    '<tr><td colspan="8" class="text-muted small fst-italic">ยังไม่มีข้อมูลเพลงของสมาชิกนี้</td></tr>';
                return;
            }
            if (pageRows.length === 0) {
                tbody.innerHTML =
                    '<tr><td colspan="8" class="text-muted small fst-italic">ไม่พบเพลงที่ตรงกับคำค้น</td></tr>';
                return;
            }
            tbody.innerHTML = pageRows
                .map(function (row, idx) {
                    var workId = String(row.work_id || "").trim();
                    var tl = String(row.title_local || "").trim();
                    var te = String(row.title_eng || "").trim();
                    var artist = String(row.artist_name || "").trim();
                    var iswc = String(row.iswc || "").trim();
                    var note = String(row.note || "").trim();
                    if (!tl && !te && !workId && !note) {
                        return "";
                    }
                    var n = start + idx + 1;
                    var viewAttr = workId ? ' data-song-view="' + escapeHtml(workId) + '"' : "";
                    var titleText = escapeHtml(tl || te || workId || "—");
                    var titleHtml = workId
                        ? '<a class="fw-semibold link-body text-decoration-none" href="#"' +
                          viewAttr +
                          ">" +
                          titleText +
                          "</a>"
                        : '<span class="fw-semibold">' + titleText + "</span>";
                    if (te && tl && te !== tl) {
                        titleHtml += '<div class="text-muted small text-break">' + escapeHtml(te) + "</div>";
                    }
                    if (artist) {
                        titleHtml += '<div class="text-muted small text-break">ศิลปิน: ' + escapeHtml(artist) + "</div>";
                    }
                    var workHtml = '<div class="font-monospace user-select-all text-break">' + escapeHtml(workId || "—") + "</div>";
                    if (iswc) {
                        workHtml += '<div class="text-muted small font-monospace user-select-all">ISWC: ' + escapeHtml(iswc) + "</div>";
                    }
                    var actionHtml = workId
                        ? '<button type="button" class="btn btn-sm btn-soft-info btn-icon" data-song-view="' +
                          escapeHtml(workId) +
                          '" title="ดูข้อมูลเพลง" aria-label="ดูข้อมูลเพลง"><i class="ri-eye-line"></i></button>'
                        : "";
                    return (
                        "<tr>" +
                        '<td class="text-muted">' +
                        n +
                        "</td>" +
                        '<td class="text-break">' +
                        titleHtml +
                        "</td>" +
                        "<td>" +
                        workHtml +
                        "</td>" +
                        '<td class="mct-profile-song-role-col is-melody">' +
                        renderSongRoleColumn(row.collaborators && row.collaborators.melody) +
                        "</td>" +
                        '<td class="mct-profile-song-role-col is-lyrics">' +
                        renderSongRoleColumn(row.collaborators && row.collaborators.lyrics) +
                        "</td>" +
                        '<td class="mct-profile-song-role-col is-arrangement">' +
                        renderSongRoleColumn(row.collaborators && row.collaborators.arrangement) +
                        "</td>" +
                        '<td class="mct-profile-song-role-col is-publisher">' +
                        renderSongRoleColumn(row.collaborators && row.collaborators.publisher) +
                        "</td>" +
                        '<td class="text-end">' +
                        actionHtml +
                        "</td>" +
                        "</tr>"
                    );
                })
                .filter(Boolean)
                .join("");
        }

        function bindSongWorksPager() {
            if (songWorksState.bound) {
                return;
            }
            var searchEl = document.getElementById("mct-song-works-search");
            var perPageEl = document.getElementById("mct-song-works-per-page");
            var pager = document.getElementById("mct-song-works-pager");
            if (searchEl) {
                searchEl.addEventListener("input", function () {
                    var value = searchEl.value;
                    if (songWorksState.searchTimer) {
                        clearTimeout(songWorksState.searchTimer);
                    }
                    songWorksState.searchTimer = setTimeout(function () {
                        songWorksState.query = String(value || "");
                        songWorksState.page = 1;
                        renderSongWorksPage();
                    }, 250);
                });
            }
            if (perPageEl) {
                perPageEl.addEventListener("change", function () {
                    var v = Number(perPageEl.value);
                    songWorksState.perPage = v === 25 || v === 50 ? v : 10;
                    songWorksState.page = 1;
                    renderSongWorksPage();
                });
            }
            if (pager) {
                pager.addEventListener("click", function (e) {
                    var stepBtn = e.target.closest("[data-song-page-step]");
                    var pageBtn = e.target.closest("[data-song-page]");
                    var nextPage = songWorksState.page;
                    if (stepBtn) {
                        nextPage = songWorksState.page + Number(stepBtn.getAttribute("data-song-page-step") || 0);
                    } else if (pageBtn) {
                        nextPage = Number(pageBtn.getAttribute("data-song-page") || songWorksState.page);
                    } else {
                        return;
                    }
                    if (!nextPage || nextPage === songWorksState.page) {
                        return;
                    }
                    songWorksState.page = nextPage;
                    renderSongWorksPage();
                });
            }
            var tbody = document.getElementById("mct-song-works-body");
            if (tbody) {
                tbody.addEventListener("click", function (e) {
                    var trigger = e.target.closest("[data-song-view]");
                    var id;
                    if (!trigger) {
                        return;
                    }
                    e.preventDefault();
                    id = String(trigger.getAttribute("data-song-view") || "").trim();
                    if (id && hooks && typeof hooks.onViewSong === "function") {
                        hooks.onViewSong(id);
                    }
                });
            }
            songWorksState.bound = true;
        }

        function renderSongWorks(rows) {
            songWorksState.all = Array.isArray(rows) ? rows : [];
            songWorksState.query = "";
            songWorksState.page = 1;
            var searchEl = document.getElementById("mct-song-works-search");
            if (searchEl) {
                searchEl.value = "";
            }
            bindSongWorksPager();
            renderSongWorksPage();
        }

        function renderHeirs(rows) {
            var tbody = document.getElementById("mct-heir-rows");
            if (!tbody) {
                return;
            }
            if (!rows || rows.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-muted small fst-italic">ยังไม่มีข้อมูลทายาท</td></tr>';
                return;
            }
            var html = rows.map(function (row) {
                return (
                    "<tr>" +
                    "<td>" + escapeHtml(safeDash(row.member_code)) + "</td>" +
                    "<td>" + escapeHtml(safeDash(row.display_name)) + "</td>" +
                    "<td>" + escapeHtml(safeDash(row.internal_no_mis)) + "</td>" +
                    "<td>" + escapeHtml(safeDash(row.ipi_name_no)) + "</td>" +
                    "<td>" + escapeHtml(safeDash(row.relationship_status)) + "</td>" +
                    "</tr>"
                );
            });
            tbody.innerHTML = html.join("");
        }

        function formatAuditTime(raw) {
            var t = String(raw || "").trim();
            if (!t) {
                return "—";
            }
            var ts = Date.parse(t.replace(" ", "T"));
            if (isNaN(ts)) {
                return t;
            }
            var d = new Date(ts);
            var pad = function (n) {
                return String(n).padStart(2, "0");
            };
            return pad(d.getDate()) + "/" + pad(d.getMonth() + 1) + "/" + d.getFullYear() + " " + pad(d.getHours()) + ":" + pad(d.getMinutes());
        }

        function formatAuditValue(v) {
            var t = String(v || "").trim();
            if (!t) {
                return "—";
            }
            return escapeHtml(t).replace(/\n/g, "<br>");
        }

        function renderAuditLogs(logs) {
            var tbody = document.getElementById("mct-profile-audit-body");
            if (!tbody) {
                return;
            }
            var rows = Array.isArray(logs) ? logs : [];
            if (!rows.length) {
                tbody.innerHTML = '<tr><td colspan="4" class="text-muted text-center py-4">ยังไม่มีประวัติ — จะปรากฏเมื่อมีการเพิ่มหรือแก้ไขข้อมูล</td></tr>';
                return;
            }
            tbody.innerHTML = rows.map(function (row) {
                var changes = Array.isArray(row.changes) ? row.changes : [];
                var detail = "";
                if (changes.length) {
                    detail = '<ul class="list-unstyled mb-0 small">' + changes.map(function (c) {
                        var oldV = String(c.old || "").trim();
                        var newV = String(c.new || "").trim();
                        var body = "";
                        if (!oldV && newV) {
                            body = '<div>' + formatAuditValue(c.new) + "</div>";
                        } else if (oldV && !newV) {
                            body = '<div class="text-muted">ลบ: ' + formatAuditValue(c.old) + "</div>";
                        } else {
                            body = '<div class="text-muted">เดิม: ' + formatAuditValue(c.old) + "</div>"
                                + "<div>ใหม่: " + formatAuditValue(c.new) + "</div>";
                        }
                        return '<li class="mb-2"><span class="fw-semibold text-body">' + escapeHtml(c.field_label || c.field || "") + "</span>" + body + "</li>";
                    }).join("") + "</ul>";
                } else {
                    detail = '<span class="text-muted">' + escapeHtml(row.summary || "—") + "</span>";
                }
                var actor = escapeHtml(row.actor_name || "—");
                var email = String(row.actor_email || "").trim();
                var sectionKey = String(row.section || "");
                var badgeClass = sectionKey === "registry" ? "bg-warning-subtle text-warning" : "bg-info-subtle text-info";
                return "<tr>"
                    + '<td class="text-nowrap align-top">' + escapeHtml(formatAuditTime(row.created_at)) + "</td>"
                    + '<td class="align-top"><div>' + actor + "</div>"
                    + (email ? '<div class="small text-muted">' + escapeHtml(email) + "</div>" : "")
                    + "</td>"
                    + '<td class="align-top"><span class="badge ' + badgeClass + ' text-wrap">' + escapeHtml(row.section_label || row.action_label || row.action || "—") + "</span>"
                    + '<div class="small text-muted mt-1">' + escapeHtml(row.action_label || "") + "</div></td>"
                    + '<td class="text-wrap align-top">' + detail + "</td>"
                    + "</tr>";
            }).join("");
        }

        function reloadAuditLogs() {
            if (!MEMBER_CODE || !API_URL) {
                return;
            }
            fetch(API_URL + "?action=profile_audit&member_code=" + encodeURIComponent(MEMBER_CODE), {
                method: "GET",
                headers: { "X-Requested-With": "XMLHttpRequest" }
            })
                .then(function (res) {
                    return res.json();
                })
                .then(function (data) {
                    if (data && data.success === true) {
                        renderAuditLogs(data.logs || []);
                    }
                })
                .catch(function () {});
        }

        function loadProfile() {
            if (!MEMBER_CODE) {
                if (els.empty) els.empty.classList.remove("d-none");
                return;
            }
            if (els.empty) els.empty.classList.add("d-none");

            fetch(API_URL + "?member_code=" + encodeURIComponent(MEMBER_CODE), {
                method: "GET",
                headers: { "X-Requested-With": "XMLHttpRequest" }
            })
                .then(function (res) {
                    return res.text().then(function (text) {
                        var data = {};
                        try {
                            data = text ? JSON.parse(text) : {};
                        } catch (e) {
                            throw new Error("API ไม่ได้ส่ง JSON ที่ถูกต้อง");
                        }
                        if (!res.ok) {
                            throw new Error((data && data.message) ? data.message : "โหลดโปรไฟล์ไม่สำเร็จ");
                        }
                        return data;
                    });
                })
                .then(function (data) {
                    if (!data || data.success !== true || !data.member) {
                        throw new Error((data && data.message) ? data.message : "ไม่พบข้อมูล");
                    }
                    var m = data.member;
                    var display = safeDash(m.display_name);
                    var pubLabel = "บริษัทผู้พิมพ์ผู้โฆษณา(Publisher)";
                    var isPublisher = String(m.rightsholder_type || "").trim() === pubLabel;

                    var primaryTabLabel = document.getElementById("mct-detail-tab-primary-label");
                    if (primaryTabLabel) {
                        primaryTabLabel.innerHTML = isPublisher
                            ? '<i class="ri-building-4-line align-middle me-1 text-success"></i>องค์กร (Publisher)'
                            : '<i class="ri-user-3-line align-middle me-1 text-primary"></i>ข้อมูลบุคคล/นักแต่งเพลง';
                    }
                    var penTabItem = document.getElementById("mct-detail-tab-pen-item");
                    var penTabLabel = document.getElementById("mct-detail-tab-pen-label");
                    var penPane = document.getElementById("mct-detail-pane-pen");
                    var heirTabItem = document.getElementById("mct-detail-tab-heir-item");
                    var heirTabBtn = document.getElementById("mct-detail-tab-heir-btn");
                    var heirPane = document.getElementById("mct-detail-pane-heir");
                    var penDescWrap = document.getElementById("mct-pen-pane-desc-wrap");
                    var penDesc = document.getElementById("mct-pen-pane-desc");
                    var penActionWrap = document.getElementById("mct-pen-action-wrap");
                    var songWorksCard = document.getElementById("mct-song-works-card");
                    var isSongwriterProfile = !isPublisher;
                    var isHeir = isSongwriterProfile && String(m.rightsholder_type || "").trim() === "ทายาท";
                    if (penTabLabel) {
                        penTabLabel.innerHTML = isPublisher
                            ? '<i class="ri-team-line align-middle me-1 text-info"></i>นักแต่งเพลง MCT'
                            : '<i class="ri-quill-pen-line align-middle me-1"></i>นามปากกา';
                    }
                    if (penTabItem) {
                        if (IS_SUCCESSOR_PROFILE_PAGE) {
                            penTabItem.classList.add("d-none");
                        } else {
                            penTabItem.classList.remove("d-none");
                        }
                    }
                    if (penPane && IS_SUCCESSOR_PROFILE_PAGE) {
                        penPane.classList.add("d-none");
                    }
                    if (heirTabItem) {
                        if (IS_SUCCESSOR_PROFILE_PAGE) {
                            heirTabItem.classList.add("d-none");
                        } else if (isSongwriterProfile) {
                            heirTabItem.classList.remove("d-none");
                        } else {
                            heirTabItem.classList.add("d-none");
                        }
                    }
                    if (!isSongwriterProfile && heirTabBtn && heirPane && heirPane.classList.contains("active")) {
                        var primaryBtn = document.getElementById("mct-detail-tab-primary-btn");
                        if (primaryBtn) {
                            primaryBtn.click();
                        }
                    }
                    if (penActionWrap) {
                        if (isPublisher || IS_SUCCESSOR_PROFILE_PAGE) {
                            penActionWrap.classList.add("d-none");
                        } else {
                            penActionWrap.classList.remove("d-none");
                        }
                    }
                    if (songWorksCard && IS_SUCCESSOR_PROFILE_PAGE) {
                        songWorksCard.classList.add("d-none");
                    }
                    if (penDescWrap && penDesc) {
                        if (isPublisher) {
                            penDescWrap.classList.remove("d-none");
                            penDesc.textContent = "นักแต่งเพลงในสังกัด ที่เป็นสมาชิก MCT";
                        } else {
                            penDescWrap.classList.add("d-none");
                            penDesc.textContent = "";
                        }
                    }
                    var penIpiHint = document.getElementById("mct-pen-ipi-hint");
                    if (penIpiHint) {
                        if (isPublisher || IS_SUCCESSOR_PROFILE_PAGE) {
                            penIpiHint.classList.add("d-none");
                        } else {
                            penIpiHint.classList.remove("d-none");
                        }
                    }

                    if (els.heroWrap) els.heroWrap.classList.remove("d-none");
                    if (els.headerWrap) els.headerWrap.classList.remove("d-none");
                    if (els.body) els.body.classList.remove("d-none");

                    setProfileAvatar(display === "—" ? "" : display, m.profile_image_path || "");
                    if (els.displayName) els.displayName.textContent = display;
                    if (els.subtitle) {
                        var wt = String(m.writer_type || "").trim();
                        var rt = String(m.rightsholder_type || "").trim();
                        els.subtitle.textContent = [wt, rt].filter(Boolean).join(" · ") || "—";
                    }
                    if (els.memberCode) els.memberCode.textContent = safeDash(m.member_code);
                    if (els.internalNo) els.internalNo.textContent = safeDash(m.internal_no_mis);
                    if (els.ipiName) els.ipiName.textContent = safeDash(m.ipi_name_no);

                    currentMember = m;

                    var actionCode = String(m.member_code || MEMBER_CODE || "").trim();
                    var actionBase = String(BASE_PATH || "").replace(/\/$/, "");
                    var actionRoot = (actionBase ? actionBase + "/" : "") + "main-manage-member.php?page=member_add&member_code=" + encodeURIComponent(actionCode);
                    function setContactActionLink(id, action, section, hash) {
                        var el = document.getElementById(id);
                        if (!el) return;
                        var href = actionRoot + "&contact_action=" + encodeURIComponent(action) + "&contact_section=" + encodeURIComponent(section);
                        if (hash) href += "#" + hash;
                        el.href = href;
                    }
                    setContactActionLink("mct-btn-email-add", "add", "email", "contact-email-rows");
                    setContactActionLink("mct-btn-email-edit", "edit", "email", "contact-email-rows");
                    setContactActionLink("mct-btn-email-del", "delete", "email", "contact-email-rows");
                    setContactActionLink("mct-btn-phone-add", "add", "phone", "contact-phone-rows");
                    setContactActionLink("mct-btn-phone-edit", "edit", "phone", "contact-phone-rows");
                    setContactActionLink("mct-btn-phone-del", "delete", "phone", "contact-phone-rows");
                    setContactActionLink("mct-btn-mobile-add", "add", "mobile", "contact-mobile-rows");
                    setContactActionLink("mct-btn-mobile-edit", "edit", "mobile", "contact-mobile-rows");
                    setContactActionLink("mct-btn-mobile-del", "delete", "mobile", "contact-mobile-rows");
                    setContactActionLink("mct-btn-address-add", "add", "address", "address-street");
                    setContactActionLink("mct-btn-address-edit", "edit", "address", "address-street");
                    setContactActionLink("mct-btn-address-del", "delete", "address", "address-street");
                    setContactActionLink("mct-btn-social-add", "add", "social", "contact-line-id");
                    setContactActionLink("mct-btn-social-edit", "edit", "social", "contact-line-id");
                    setContactActionLink("mct-btn-social-del", "delete", "social", "contact-line-id");

                    setText("mct-detail-member-code", m.member_code);
                    setText("mct-detail-internal-no", m.internal_no_mis);
                    setText("mct-detail-ipi-name", m.ipi_name_no);

                    applyMemberStatusBadge(m.status);
                    applyCreatedSourceBadge(m.created_source, m.created_source_label);
                    setText("mct-field-writer-type", canonicalWriterType(m.writer_type));
                    setText("mct-field-rightsholder-type", isPublisher ? pubLabel : m.rightsholder_type);
                    setText("mct-field-genre", m.genre);
                    setText("mct-field-roles", formatRoles(m));
                    setText("mct-field-affiliated-publisher", m.affiliated_publisher);
                    setText("mct-field-created", m.created_at);
                    setText("mct-field-updated", m.updated_at);
                    setText("mct-field-ipi-base", m.ipi_base_no);

                    var pi = m.personal || {};
                    if (els.personalCard) {
                        if (isPublisher) {
                            els.personalCard.classList.add("d-none");
                        } else {
                            els.personalCard.classList.remove("d-none");
                            setPersonalReadOnly(pi);
                        }
                    }

                    if (els.orgCard) {
                        if (isPublisher) {
                            els.orgCard.classList.remove("d-none");
                            var o = m.organization || {};
                            setText("mct-org-local", o.org_name_local);
                            setText("mct-org-branch", o.branch_description_local);
                            setText("mct-org-eng", o.org_name_eng);
                            setText("mct-org-trading", o.trading_name_eng);
                            setText("mct-org-tax", o.tax_id);
                            setText("mct-org-juristic", o.juristic_registration_no);
                            setText("mct-org-established", o.established_date);
                            setText("mct-org-country", o.registration_country);
                        } else {
                            els.orgCard.classList.add("d-none");
                        }
                    }

                    if (els.writerInfoSection) {
                        if (isPublisher) {
                            els.writerInfoSection.classList.add("d-none");
                        } else {
                            els.writerInfoSection.classList.remove("d-none");
                        }
                    }

                    renderContactEmails(m.emails || []);
                    renderContactPhones(m.phones || []);
                    renderContactMobiles(m.mobiles || []);
                    renderAddresses(m.addresses || m.address);

                    var soc = m.social || {};
                    setText("mct-social-line", soc.line_id);
                    setText("mct-social-fb", soc.facebook);
                    setText("mct-social-youtube", soc.youtube);
                    setText("mct-social-tiktok", soc.tiktok);
                    setText("mct-social-instagram", soc.instagram);
                    setText("mct-social-x", soc.x_twitter);
                    setText("mct-social-note", soc.contact_note);

                    renderPenNames(m.pen_names || [], m);
                    renderBankAccounts(m.bank_accounts || []);
                    renderDocumentManager(m);
                    renderSongWorks(m.song_works || []);
                    renderHeirs(m.heirs || []);
                    renderAuditLogs(m.audit_logs || []);
                })
                .catch(function (err) {
                    showAlert("danger", err.message || "โหลดข้อมูลไม่สำเร็จ");
                    if (els.empty) {
                        els.empty.classList.remove("d-none");
                        els.empty.querySelector("p").textContent =
                            err.message || "ไม่สามารถแสดงโปรไฟล์ได้";
                    }
                });
        }

        initPersonalInlineEditing();
        initWriterInlineEditing();
        initContactInlineEditing();
        initPenInlineEditing();
        initBankInlineEditing();
        initDocumentManager();
        bindAvatarUpload();
        bindSongWorksPager();
        loadBankMasterOptions().finally(function () {
            loadProfile();
        });
}

export default {
  name: "MemberProfile",
  components: { SongViewModal },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    profileTitle: function () {
      return String((this.config && this.config.profileTitle) || "โปรไฟล์สมาชิก");
    },
    listLabel: function () {
      return String((this.config && this.config.listLabel) || "รายการสมาชิกทั้งหมด");
    },
    listUrl: function () {
      return String((this.config && this.config.listUrl) || "#");
    },
    coverSrc: function () {
      var base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/assets/images/profile-cover-music.svg";
    },
    isSuccessor: function () {
      return !!(this.config && this.config.isSuccessor);
    },
    songDetailApiUrl: function () {
      var fromConfig = String((this.config && this.config.songDetailApiUrl) || "").trim();
      var base;
      if (fromConfig) {
        return fromConfig;
      }
      base = String((this.config && this.config.basePath) || "");
      return (base === "" ? "" : base) + "/actions/song-detail.php";
    },
  },
  methods: {
    openSongView: function (workId) {
      if (this.$refs.songViewModal && typeof this.$refs.songViewModal.open === "function") {
        this.$refs.songViewModal.open(workId);
      }
    },
  },
  mounted: function () {
    var self = this;
    runMemberProfile(this.config || {}, {
      onViewSong: function (workId) {
        self.openSongView(workId);
      },
    });
  },
};
</script>

<style>
    .mct-thai-font {
        font-family: "Kanit", "Noto Sans Thai", sans-serif !important;
    }

    .mct-profile-song-table > tbody > tr > td {
        vertical-align: top;
    }

    .mct-profile-song-role-head.is-melody {
        color: #2563eb !important;
    }

    .mct-profile-song-role-head.is-lyrics {
        color: #16a34a !important;
    }

    .mct-profile-song-role-head.is-arrangement {
        color: #7c3aed !important;
    }

    .mct-profile-song-role-head.is-publisher {
        color: #0891b2 !important;
    }

    .mct-profile-song-role-col {
        min-width: 8.5rem;
        max-width: 14rem;
        font-size: 0.8rem;
        line-height: 1.35;
        word-break: break-word;
    }

    .mct-profile-song-role-person + .mct-profile-song-role-person {
        margin-top: 0.25rem;
    }

    .mct-profile-song-role-person.is-self {
        font-weight: 600;
        color: #0f172a;
    }

    .mct-profile-song-collab-badge {
        display: inline-flex;
        align-items: center;
        margin-left: 0.25rem;
        padding: 0.05rem 0.4rem;
        border-radius: 999px;
        font-size: 0.65rem;
        font-weight: 600;
        line-height: 1.3;
        color: #64748b;
        background: #e2e8f0;
        vertical-align: middle;
        white-space: nowrap;
    }

    .mct-pen-table-scroll {
        height: 500px;
        overflow-y: scroll;
        overflow-x: auto;
    }

    .mct-bank-select-xs {
        font-size: 0.75rem;
        line-height: 1.2;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
    }

    #mct-bank-accounts-body .choices__inner {
        min-height: 30px;
        padding-top: 2px;
        padding-bottom: 2px;
        font-size: 0.75rem;
        line-height: 1.2;
    }

    #mct-bank-accounts-body .choices[data-type*="select-one"]::after {
        margin-top: -3px;
    }

    .mct-profile-user {
        position: relative;
        display: inline-block;
    }

    .mct-profile-avatar-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .mct-profile-photo-edit {
        position: absolute;
        right: -0.25rem;
        bottom: -0.25rem;
        z-index: 2;
    }

    .mct-docs-fm .mct-docs-quota {
        min-width: 180px;
        max-width: 280px;
        flex: 1 1 180px;
    }

    .mct-docs-fm .mct-docs-quota-bar {
        height: 6px;
        border-radius: 99px;
        background: rgba(64, 81, 137, 0.12);
    }

    .mct-docs-fm .mct-docs-sidebar {
        background: var(--vz-light, #f8f9fb);
        border: 1px solid var(--vz-border-color, #e9ebec);
        border-radius: 0.75rem;
        padding: 0.75rem;
        max-height: min(520px, 60vh);
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .mct-docs-fm .mct-docs-tree {
        display: flex;
        flex-direction: column;
        gap: 0.15rem;
    }

    .mct-docs-fm .mct-docs-tree-item {
        display: flex;
        align-items: center;
        gap: 0.45rem;
        width: 100%;
        border: 0;
        background: transparent;
        text-align: left;
        padding: 0.42rem 0.5rem;
        border-radius: 0.5rem;
        color: inherit;
        font-size: 0.8125rem;
        line-height: 1.3;
    }

    .mct-docs-fm .mct-docs-tree-item:hover {
        background: rgba(64, 81, 137, 0.08);
    }

    .mct-docs-fm .mct-docs-tree-item.is-active {
        background: rgba(64, 81, 137, 0.12);
        color: var(--vz-primary, #405189);
        font-weight: 600;
    }

    .mct-docs-fm .mct-docs-breadcrumb {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        min-height: 1.75rem;
    }

    .mct-docs-fm .mct-docs-crumb {
        background: none;
        border: 0;
        padding: 0;
        color: var(--vz-primary, #405189);
        font-size: inherit;
        line-height: inherit;
    }

    .mct-docs-fm .mct-docs-crumb:hover {
        text-decoration: underline;
    }

    .mct-docs-fm .mct-docs-crumb.is-current {
        color: inherit;
        font-weight: 600;
        pointer-events: none;
        text-decoration: none;
    }

    .mct-docs-fm .mct-docs-search {
        position: relative;
        min-width: 180px;
    }

    .mct-docs-fm .mct-docs-search i {
        position: absolute;
        left: 0.65rem;
        top: 50%;
        transform: translateY(-50%);
        color: var(--vz-secondary-color, #878a99);
        pointer-events: none;
    }

    .mct-docs-fm .mct-docs-search input {
        padding-left: 1.85rem;
        border-radius: 999px;
    }

    .mct-docs-fm .mct-docs-folder-form {
        background: var(--vz-light, #f8f9fb);
        border: 1px dashed var(--vz-border-color, #e9ebec);
        border-radius: 0.65rem;
        padding: 0.75rem 0.85rem;
    }

    .mct-docs-fm .mct-docs-dropzone {
        border: 1.5px dashed var(--vz-border-color, #ced4da);
        border-radius: 0.85rem;
        padding: 1.15rem 1rem;
        text-align: center;
        background: linear-gradient(180deg, #fbfcfe 0%, #f4f6fa 100%);
        cursor: pointer;
        transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
    }

    .mct-docs-fm .mct-docs-dropzone:hover,
    .mct-docs-fm .mct-docs-dropzone.is-dragover {
        border-color: var(--vz-primary, #405189);
        background: rgba(64, 81, 137, 0.06);
        box-shadow: 0 0 0 3px rgba(64, 81, 137, 0.08);
    }

    .mct-docs-fm .mct-docs-dropzone.is-uploading {
        pointer-events: none;
        opacity: 0.72;
    }

    .mct-docs-fm .mct-docs-dropzone-icon {
        width: 2.75rem;
        height: 2.75rem;
        margin: 0 auto 0.5rem;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--vz-primary-bg-subtle, #e2e5f3);
        color: var(--vz-primary, #405189);
        font-size: 1.35rem;
    }

    .mct-docs-fm .mct-docs-files {
        max-height: min(520px, 58vh);
        overflow-y: auto;
        overscroll-behavior: contain;
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        padding-right: 0.15rem;
    }

    .mct-docs-fm .mct-docs-subfolders {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
        gap: 0.65rem;
    }

    .mct-docs-fm .mct-docs-folder-card {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.15rem;
        border: 1px solid var(--vz-border-color, #e9ebec);
        background: #fff;
        border-radius: 0.7rem;
        padding: 0.7rem 0.8rem;
        text-align: left;
        min-width: 0;
    }

    .mct-docs-fm .mct-docs-folder-card:hover {
        border-color: var(--vz-primary, #405189);
        background: rgba(64, 81, 137, 0.04);
    }

    .mct-docs-fm .mct-docs-folder-card i {
        font-size: 1.35rem;
        line-height: 1;
    }

    .mct-docs-fm .mct-docs-file-row {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.7rem 0.8rem;
        border-radius: 0.7rem;
        border: 1px solid transparent;
        background: #fff;
    }

    .mct-docs-fm .mct-docs-file-row:hover {
        background: var(--vz-light, #f8f9fb);
        border-color: var(--vz-border-color, #e9ebec);
    }

    .mct-docs-fm .mct-docs-file-icon {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 0.55rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 1.2rem;
        flex-shrink: 0;
    }

    .mct-docs-fm .mct-docs-thumb {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: cover;
        border-radius: 0.55rem;
        flex-shrink: 0;
        border: 1px solid var(--vz-border-color, #e9ebec);
    }

    @media (max-width: 991.98px) {
        .mct-docs-fm .mct-docs-sidebar {
            max-height: 180px;
        }
    }

</style>
